(function($) {


    var eu_countries = ['gb', 'at', 'be', 'bg', 'cy', 'cz', 'de', 'dk', 'ee', 'es', 'fi', 'fr', 'gr', 'hr', 'hu', 'ie', 'it', 'lt', 'lu', 'lv', 'mt', 'nl', 'po', 'pt', 'ro', 'se', 'si', 'sk', 'pl'];

    $('.opt').on('click', '.primary-file-download-icon-word', function(e) {
        e.stopPropagation();
    });

    $('.opt').on('click', '.primary-file-download-icon-excel', function(e) {
        e.stopPropagation();
    });


    function WebpIsSupported(callback) {
        // If the browser doesn't has the method createImageBitmap, you can't display webp format
        if (!window.createImageBitmap) {
            callback(false);
            return;
        }

        // Base64 representation of a white point image
        var webpdata = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=';

        // Retrieve the Image in Blob Format
        fetch(webpdata).then(function(response) {
            return response.blob();
        }).then(function(blob) {
            // If the createImageBitmap method succeeds, return true, otherwise false
            createImageBitmap(blob).then(function() {
                callback(true);
            }, function() {
                callback(false);
            });
        });
    }


    $('iframe').each(function(index) {
        var src = $(this).data('src');
        $(this).attr("src", src);
        console.log(src);
    });

    WebpIsSupported(function(isSupported) {
        // return;
        if (!isSupported) {
            $('html').addClass("no-webp");
        }

        $("img").each(function(index) {
            // console.log($(this));
            var src = $(this).data('src');
            var srcset = $(this).data('srcset');

            // console.log(isSupported);

            if (isSupported) {
                // console.log(src);
                if (typeof src !== 'undefined') {
                    src = src.replace(".png", ".webp");
                    src = src.replace(".jpg", ".webp");
                    src = src.replace(".jpeg", ".webp");
                }

                if (typeof srcset !== 'undefined') {
                    srcset = srcset.replace(".png", ".webp");
                    srcset = srcset.replace(".jpg", ".webp");
                    srcset = srcset.replace(".jpeg", ".webp");
                    srcset = '.png'.replace(/\+/g, '.webp');
                    srcset = '.png'.replace(/\+/g, '.webp');
                    srcset = '.png'.replace(/\+/g, '.webp');
                    // console.log('this part');
                }
            } else {
                // $('html').addClass("no-webp");
            }

            $(this).attr("src", src);
            $(this).data("srcset", srcset);
        });

    });


    // if webp is not found fallback to original
    $('img').error(function() {
        var original_src = $(this).data('src');
        var checked = $(this).data('checked');

        if (checked == 'yes') {
            return;
        } else {
            $(this).attr('src', original_src);
            var checked = $(this).data('checked', 'yes');
        }

    });


    // get google ads click ID of this session
    function save_google_ad_click_id() {

        var key = 'gclid';
        var value = getUrlParameter('gclid');

        // if glid undefined exit function
        if (typeof value === 'undefined') {
            return;
        }

        // Save cookie
        document.cookie = key + '=' + value + '; path=/';

    }

    function get_google_ad_click_id() {
        var gclid = getCookie('gclid');
        if (gclid === null) {
            gclid = '';
        }
        return gclid;
    }


    //
    // "use strict";
    //
    // var BJLL_options = BJLL_options || {};
    //
    // var BJLL = {
    //
    //   _ticking: false,
    //
    //   check: function () {
    //
    //       if ( BJLL._ticking ) {
    //           return;
    //       }
    //
    //       BJLL._ticking = true;
    //
    //       if ( 'undefined' == typeof ( BJLL.threshold ) ) {
    //           if ( 'undefined' != typeof ( BJLL_options.threshold ) ) {
    //               BJLL.threshold = parseInt( BJLL_options.threshold );
    //           } else {
    //               BJLL.threshold = 200;
    //           }
    //       }
    //
    //       var winH = document.documentElement.clientHeight || body.clientHeight;
    //
    //       var updated = false;
    //
    //       var els = document.getElementsByClassName('lazy-hidden');
    //       [].forEach.call( els, function( el, index, array ) {
    //
    //           var elemRect = el.getBoundingClientRect();
    //
    //           if ( winH - elemRect.top + BJLL.threshold > 0 ) {
    //               BJLL.show( el );
    //               updated = true;
    //           }
    //
    //       } );
    //
    //       BJLL._ticking = false;
    //       if ( updated ) {
    //           BJLL.check();
    //       }
    //   },
    //
    //   show: function( el ) {
    //       el.className = el.className.replace( /(?:^|\s)lazy-hidden(?!\S)/g , '' );
    //       el.addEventListener( 'load', function() {
    //           el.className += " lazy-loaded";
    //           BJLL.customEvent( el, 'lazyloaded' );
    //       }, false );
    //
    //       var type = el.getAttribute('data-lazy-type');
    //
    //       if ( 'image' == type ) {
    //           if ( null != el.getAttribute('data-lazy-srcset') ) {
    //               el.setAttribute( 'srcset', el.getAttribute('data-lazy-srcset') );
    //           }
    //           if ( null != el.getAttribute('data-lazy-sizes') ) {
    //               el.setAttribute( 'sizes', el.getAttribute('data-lazy-sizes') );
    //           }
    //           el.setAttribute( 'src', el.getAttribute('data-lazy-src') );
    //       } else if ( 'iframe' == type ) {
    //           var s = el.getAttribute('data-lazy-src'),
    //               div = document.createElement('div');
    //
    //           div.innerHTML = s;
    //           var iframe = div.firstChild;
    //           el.parentNode.replaceChild( iframe, el );
    //       }
    //
    //   },
    //
    //   customEvent: function( el, eventName ) {
    //       var event;
    //
    //       if ( document.createEvent ) {
    //           event = document.createEvent( "HTMLEvents" );
    //           event.initEvent( eventName, true, true );
    //       } else {
    //           event = document.createEventObject();
    //           event.eventType = eventName;
    //       }
    //
    //       event.eventName = eventName;
    //
    //       if ( document.createEvent ) {
    //           el.dispatchEvent( event );
    //       } else {
    //           el.fireEvent( "on" + event.eventType, event );
    //       }
    //   }
    //
    // }

    // window.addEventListener( 'load', BJLL.check, false );
    // window.addEventListener( 'scroll', BJLL.check, false );
    // window.addEventListener( 'resize', BJLL.check, false );
    // document.getElementsByTagName( 'body' ).item( 0 ).addEventListener( 'post-load', BJLL.check, false );

    // $(window).load(function(){
    //   // $("footer").append("<script type='text/javascript' src='//localhost:3000/wp-content/plugins/bj-lazy-load/js/bj-lazy-load.min.js?ver=2'></script>");
    //
    //   if (check_if_mobile() ){
    //     BJLL.check();
    //   }
    //   //
    //   // BJLL.check();
    //   // setTimeout(
    //   // function() {
    //   //     BJLL.check();
    //   //  }, 1000);
    //
    //   window.addEventListener( 'mousemove', BJLL.check, false );
    //   window.addEventListener( 'load', BJLL.check, false );
    //   window.addEventListener( 'scroll', BJLL.check, false );
    //   window.addEventListener( 'resize', BJLL.check, false );
    //   document.getElementsByTagName( 'body' ).item( 0 ).addEventListener( 'post-load', BJLL.check, false );
    //
    // });

    // CURRENCIES SCRIPTS

    function isFunction(fn) {
        return typeof fn === 'function'
    }

    function isDefined(foo) {
        return foo !== 'undefined'
    }

    $(document).ready(function() {
        var cookie_name = 'RoyaltyRange_currency';
        var currency_cookie = getCookie(cookie_name);
        var currency = currency_cookie;
        var admin_currency = null;

        if ($('.admin-currency').length) {
            var admin_currency_cookie = getCookie('admin_RoyaltyRange_currency');

            if (admin_currency_cookie == 'eur' || admin_currency_cookie == 'usd') {
                admin_currency = admin_currency_cookie;
            } else {
                admin_currency = null;
            }
        }


        if ($("body").hasClass("user-logged-in")) {
            load_additional_assets();
        }

        // if ( $('.found-via').length > 0){
        //     try { $('.found-via').SumoSelect();} catch(err) { }
        // }

        save_google_ad_click_id();

        if (currency === null && admin_currency === null) {

            $.ajax({
                url: ajax_object.ajaxurl,
                type: "post",
                data: {
                    action: "ajax_get_user_currency",
                },
                success: function(result) {
                    currency = $.trim(result);

                    if (currency != 'eur') {
                        currency = 'usd';
                    }
                    console.log('new: ' + currency);
                    setCookie(cookie_name, currency);
                    activate_currency(currency);

                },
                error: function(result) {}
            });

        } else {

            if (admin_currency) {
                currency = admin_currency;
            }
            activate_currency(currency);

        }

        privacy_cookies_notification();

        login_popup();

    });

    function login_popup() {

        if ($("h1.login-auto-popup").length) {

            $('.login-popup').toggleClass('show');
            $('.background-overlay').toggleClass('show');
            $('#user_login').focus();

        }

    }

    $("html").mousemove(function() {
        // load_additional_assets();
    });
    $(window).scroll(function() {
        // load_additional_assets();
    });

    var load_assets = false;

    function load_additional_assets() {
        if (load_assets) return;

        if ($('#front-page-one-search-nic-sic-forms').length) {
            // homepage_one_search_form_activate_load_assets();
        } else {

            $($("span.load-later")).each(function(index) {
                var type = $(this).data('type');
                var src = $(this).data('src');
                var handle = $(this).attr('id');
                var html = "";

                if (type == "style") {
                    html = '<link rel="stylesheet" id="' + handle + '" href="' + src + '" media="all">';
                }

                if (type == "script") {
                    html = '<script type="text/javascript" src="' + src + '"></script>';
                }

                $("footer").append(html);

            });
        }


        load_assets = true;

    }

    var load_tags = 0;
    var landing_data_upload = 0;

    function load_tarcking_tags() {
        if (load_tags === 0) {
            // load_global_meta_tags();
            // tag_manager_tag_after_body();
            facebook_pixel_tracking_code();
            load_tags = 1;
        }
        // else{
        //     if (landing_data_upload == 0){
        //         var landing_page_info = $(".stripe-payment-landing-page-info").data("landing-page-info");
        //         // console.log(landing_page_info);
        //
        //         if (landing_page_info != "" && landing_page_info){
        //             if ( typeof dataLayer !== 'undefined') {
        //                 // dataLayer.push({'event': 'LandingPageOneSearchReadyMade', 'formName':'demoRequest'});
        //                 landing_data_upload = 1;
        //                 console.log('defined');
        //             }else{
        //                 console.log('undefined');
        //             }
        //         }
        //     }

        // }
    }
    $("html").mousemove(function() {
        load_tarcking_tags();
    });
    $(window).scroll(function() {
        load_tarcking_tags();
    });

    //
    // function load_global_meta_tags(){
    //     $.ajax({
    //         url: ajax_object.ajaxurl,
    //         type: "post",
    //         data: {
    //             action: "load_global_meta_tags",
    //         },
    //         success: function(result) {
    //             $('head').append(result);
    //         }
    //     });
    // }
    // function tag_manager_tag_after_body(){
    //
    //     $.ajax({
    //         url: ajax_object.ajaxurl,
    //         type: "post",
    //         data: {
    //             action: "tag_manager_tag_after_body",
    //         },
    //         success: function(result) {
    //             $('body').prepend(result);
    //         }
    //     });
    // }

    function facebook_pixel_tracking_code() {

        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            data: {
                action: "facebook_pixel_tracking_code",
            },
            success: function(result) {
                $('body').prepend(result);
            }
        });
    }

    //=====================================================PRIVACY POLICY FUNCTOINS START==================================================================
    function privacy_cookies_notification() {

        var cookie_name = 'RR_privacy_agreement';
        var RR_privacy_agreement = getCookie(cookie_name);


        if (RR_privacy_agreement == '1') {
            return;
        } else {

            $('header').after('<div class="privacy-notification"><p class="width-wrap">We use cookies to ensure that we give you the best experience on our website, as explained in our <a href="/privacy-policy">cookie policy</a>. If you agree to our use of cookies, please close this message and continue to use the site. Certain website features like live support may not work with cookies switched off. If you change your mind regarding our cookies use, you can edit the settings on our <a href="/privacy-policy">policy page</a>. <a class="accept-to-cookies">Accept & close</a></p></div>');

        }

    }

    $('body').on('click', '.accept-to-cookies', function(e) {
        e.preventDefault();

        $('.privacy-notification').remove();

        var key = 'RR_privacy_agreement';
        var expires = new Date();
        value = '1';
        var expires = new Date('2030', '5', '25');

        document.cookie = key + '=' + value + ';expires=' + expires + '; path=/';
        $('.sticky-chat-container').remove();
        privacy_cookies_notification();

    });

    // agree at privacy policy page
    $('body').on('click', '.agree-privacy-policy', function(e) {
        e.preventDefault();

        $('.privacy-notification').remove();

        var key = 'RR_privacy_agreement';
        var expires = new Date();
        value = '1';
        var expires = new Date('2030', '5', '25');

        document.cookie = key + '=' + value + ';expires=' + expires + '; path=/';

        location.reload();

    });

    // disagree at privacy policy page
    $('body').on('click', '.disagree-privacy-policy', function(e) {
        e.preventDefault();

        var key = 'RR_privacy_agreement';
        var value = 'null';

        document.cookie = key + '=; expires=Thu, 01-Jan-70 00:00:01 GMT;';


        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            data: {
                action: 'ajaxlogout', //calls wp_ajax_nopriv_ajaxlogout
            },
            success: function(data) {
                location.reload();
            }
        });

        e.preventDefault();

    });

    //=====================================================PRIVACY POLICY FUNCTOINS END==================================================================

    function activate_currency(currency) {


        $('html').addClass('user-currency-' + currency);
        $("html").trigger("currency");
        $('#request-form').attr('data-user-currency', currency);

        if (currency == 'eur') {
            $('span.price-usd').remove();
            $('div.price-usd').remove();

            $('span.price-eur').each(function(index) {
                var price = $(this).data('price');
                $(this).html(price);
            });
            $('div.price-eur').each(function(index) {
                var price = $(this).data('price');
                $(this).html(price);
            });

        } else {
            $('span.price-eur').remove();
            $('div.price-eur').remove();

            $('span.price-usd').each(function(index) {
                var price = $(this).data('price');
                $(this).html(price);
            });
            $('div.price-usd').each(function(index) {
                var price = $(this).data('price');
                $(this).html(price);
            });
        }


        $('input[name="subscription-plan"]').each(function(index, el) {
            var price = '';

            if (currency == 'usd') {
                price = $(this).data('price-usd');
                $(this).attr('data-price-eur', '');
            } else {
                price = $(this).data('price-eur');
                $(this).attr('data-price-usd', '');
            }

            var value = $(this).val();
            $(this).val(value + price);

        });


        // currency switcher
        if ($('.admin-currency').length) {
            var admin_currency_cookie = getCookie('admin_RoyaltyRange_currency');

            $('.set-currency').removeClass('selected');
            if (admin_currency_cookie == 'usd' || admin_currency_cookie == 'eur') {
                $('.set-currency[data-set-currency="' + admin_currency_cookie + '"]').addClass('selected');
            }
        }

        // Request form pricing


    }

    function setCookie(key, value) {

        var cookie_name = 'RR_privacy_agreement';
        var RR_privacy_agreement = getCookie(cookie_name);

        var expires = new Date();
        var cookie_duration = 1000 * 60 * 60 * 24 * 7;
        expires.setTime(expires.getTime() + cookie_duration);
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + '; path=/';

    }


    function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    }

    function removeCookie(key) {
        document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
    }

    $('body').on('click', '.set-currency', function() {
        var currency = $(this).data('set-currency');

        if ($(this).hasClass('selected')) {

            removeCookie('admin_RoyaltyRange_currency');
            location.reload();

        } else {

            $('.set-currency').removeClass('selected');

            if (currency == 'usd') {
                $('.set-currency[data-set-currency="usd"]').addClass('selected');
            } else {
                $('.set-currency[data-set-currency="eur"]').addClass('selected');
            }

            // setCookie('admin_RoyaltyRange_currency', currency);
            setCookie('admin_RoyaltyRange_currency', currency);
            location.reload();
        }

    });


    loader = '<div class="admin-containers-loader"><svg version="1.1" class="svg-loader" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve"><path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/> <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.5s" repeatCount="indefinite"/> </path></svg></div>';
    user_password_reset_loader = '<div class="user-password-reset-loader"><svg version="1.1" class="svg-loader" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve"><path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/> <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.5s" repeatCount="indefinite"/> </path></svg></div>';

    // NOTIFICATION
    $('.dropdown').click(function() {
        $(this).toggleClass('active');
    });

    // HEADER FIXED ANIMATIONS AND SCRIPTS
    $(document).on('scroll', function() {
        make_menu_sticky();
    });

    $(document).on('ready', function() {
        make_menu_sticky();
    });

    $(window).on("load", function() {
        make_menu_sticky();
    });

    function make_menu_sticky() {
        var from_top = $(window).scrollTop();
        // console.log(from_top);
        if (from_top > 64) {
            $('.large-menu-holder').addClass('fixed');
        } else if (from_top <= 64 && $('.large-menu-holder').hasClass('fixed')) {
            $('.large-menu-holder').removeClass('fixed');
        }

        if (from_top > 90) {
            $('.large-menu-holder').addClass('shrink');
        } else if (from_top <= 90 && $('.large-menu-holder').hasClass('shrink')) {
            $('.large-menu-holder').removeClass('shrink');
        }

        // remove active class from first large menu item

    }

    $(".large-menu li.menu-item-has-children").on("mouseover", function() {
        //stuff to do on mouseover
    });

    var timeout;
    $('.large-menu li.menu-item-has-children').hover(
        function() {

        },
        function() {
            timeout = setTimeout(function() {
                // do stuff on hover
                // console.log('in');
            }, 1000);
            clearTimeout(timeout);
            // do stuff when hover off
            // console.log('out');

        }
    );

    // $(function() {
    //     var delayms = 500;
    //     var lock = false;

    //     $(".large-menu li").mouseenter(function(event) {

    //         if (lock === false) {
    //             if ($(this).hasClass('menu-item-has-children')) {
    //                 lock = true;
    //                 $(this).addClass('box-hover');
    //                 // if (!$(".large-menu > div > ul > li").hasClass('box-hover')) {
    //                 $(".large-menu li").not(this).addClass('remove-hover');
    //                 // }
    //                 $(".large-menu li").mouseleave(function() {
    //                     window.setTimeout(function() {
    //                         $('.large-menu li').removeClass('box-hover');
    //                         $('.large-menu li').removeClass('remove-hover');
    //                         console.log('boxas-out');
    //                         lock = false;
    //                     }, delayms);
    //                 });
    //             }
    //         } else {
    //             console.log('Isjungiam');
    //             // event.preventDefault();

    //         }

    //     });

    // });

    $('.mobile-menu .menu-item').click(function() {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $('.mobile-menu .menu-item').removeClass('active');
            $(this).addClass('active');
        }
    });

    $('.mobile-menu .menu-item div').click(function() {
        var menu = $(this).data('menu');
        var element = $('.menu-container[data-menu="' + menu + '"]');

        if (element.hasClass('show')) {
            element.removeClass('show');
        } else {
            $('.menu-container').removeClass('show');
            element.addClass('show');
        }
    });

    $('.menu-item-has-children a').click(function(e) {
        var window_width = viewportWidth();

        if (window_width <= 1185) {

            if ($(this).parent().closest('li').hasClass('menu-item-has-children')) {
                e.preventDefault();
                $(this).parent('li').toggleClass('active');
            }
        }
    });

    function maintenance_enabled() {
        var result = false;
        if ($('html').hasClass('maintenance')) {
            result = true;
        }
        return result;
    }


    $('#close-maintanance-form').click(function() {
        $('.background-overlay').toggleClass('show');
        $('.maintanance-form').toggleClass('show');
    })

    // MENU DROPDOWN AND LOGIN POPUP
    // ============================================================================================================

    // before logging in show loader
    $('#wp-submit').click(function(e) {
        $('.login-popup-loader-conatiner').append(loader);
        $('.login-popup-loader-conatiner').css('display', 'block');

        $(this).css('display', 'none');
        $('#linkedin-login').remove();
        $('#registration-page-link').remove();

        var today = new Date().toJSON();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'formSubmitSuccess',
            timeStamp: today,
            form_name: 'LoginForm',
            form_id: '11127',
        });
    });

    $('.login').click(function(e) {

        if (maintenance_enabled()) {

            $('.background-overlay').toggleClass('show');
            $('.maintanance-form').toggleClass('show');
            display_maintanance_form();
            return;
        }

        $('.login-popup').toggleClass('show');
        $('.background-overlay').toggleClass('show');
        $('#user_login').focus();
    });

    $('.close-form').click(function() {
        $('.popup-form').removeClass('show');
        $('.background-overlay').removeClass('show');
    });

    $('body').keyup(function(e) {
        if (e.keyCode == 27) { // escape key maps to keycode `27`
            $('.popup-form').removeClass('show');
            $('.background-overlay').removeClass('show');
            $(".payments-wrapper").css("display", "none");
        }
    });

    $('.background-overlay').click(function() {
        $(this).removeClass('show');
        $('.login-popup').removeClass('show');
        $('.maintanance-form').removeClass('show');
        $('#Nace-2-form').removeClass('show');
        $('#country-form').removeClass('show');
        $('#profitlevel-form').removeClass('show');
        $('#SIC-form').removeClass('show');
        $('.popup-form').removeClass('show');
    });

    $('.forgot-password').click(function(e) {
        show_reset_password_form(e);
    });

    $('.resend-email').click(function(e) {
        show_reset_password_form(e);
    });

    function show_reset_password_form(e) {
        e.preventDefault();
        $('.background-overlay').addClass('show');
        $('.login-popup').removeClass('show');
        $('.password-reset-form').toggleClass('show');
        $("#user-email").focus();
    }

    $('#close-reset-form').click(function() {
        $('.password-reset-form').removeClass('show');
        $('.background-overlay').removeClass('show');
    });


    // SEND PASSWORD RESET EMAIL
    // ============================================================================================================

    // $('body').on('click', '#send-reset-link', function(){
    //
    // });

    $('#send-reset-link').click(function() {
        send_password_reset_link();
    });

    $('#user-email').keyup(function(e) {
        if (e.keyCode == 13) {
            send_password_reset_link();
        }
    });

    function send_password_reset_link() {
        var user_email = $("#user-email").val();

        $('#send-reset-link').css('display', 'none');
        $('.password-reset-loader-container').css('display', 'block');

        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            data: {
                action: "ajax_password_reset_email",
                email: user_email,
            },
            success: function(result) {

                $.trim(result);
                if (result == ' User does not exist' || result == ' The email you have entered is invalid') {
                    $('.password-reset-message').text('Could not find information for this user');
                    $('.password-reset-loader-container').css('display', 'none');
                    $('#send-reset-link').css('display', 'block');
                    $('#user-email').addClass('error');
                } else if (result == ' Email has been sent successfully') {
                    $('.password-reset-loader-container').css('display', 'none');
                    $('.password-reset-message').html('An email has been sent to <strong>' + user_email + '</strong> with instructions how to reset your password.  Thank you.');
                    $('#close-reset-form').css('display', 'block');
                    $('#send-reset-link').css('display', 'none');
                    $("#user-email").css('display', 'none');
                    $('.password-reset-form label').css('display', 'none');
                }
            },
            error: function(result) {
                $('.password-reset-loader-container').css('display', 'none');
            }
        });
    }

    // REGISTRATION FORM
    // ============================================================================================================

    $('#registration-linkedin-login').click(function(e) {
        if (maintenance_enabled()) {
            e.preventDefault();
            $('.background-overlay').toggleClass('show');
            $('.maintanance-form').toggleClass('show');
            display_maintanance_form();
            return;
        }
    });



    $("#submit-registration-form").click(function(e) {
        var error = false;

        if (maintenance_enabled()) {
            e.preventDefault();
            $('.background-overlay').toggleClass('show');
            $('.maintanance-form').toggleClass('show');
            display_maintanance_form();
            return
        }

        if ($('#submit-registration-form .allow-send').val()) {
            return;
        }

        $('.registration-form .form-message-container').css('display', 'none');
        $('.registration-form .form-message-container p').text('');
        $('.registration-form input').removeClass('error');
        $('#licence-agreement-label').removeClass('error');
        var message = '';

        // IF REQUIRED FIELDS ARE EMPTY
        $('.registration-form .required').each(function(index) {
            if (!$(this).val()) {
                $(this).addClass('error');
                message = "You must fill all required fields.";
                $('.form-message-bad').text(message);
                $('.form-message-container').css('display', 'block');
                error = true;
            }
        });

        if (error) {
            return;
        }

        var user_firstname = sanitize($('.registration-form input[name="user_firstname"]').val());
        var user_surname = sanitize($('.registration-form input[name="user_surname"]').val());
        var user_email = sanitize($('.registration-form input[name="user_email"]').val());
        var user_country = sanitize($('.registration-form input[name="user_country"]').val());
        var user_company = sanitize($('.registration-form input[name="user_company"]').val());
        var user_job = sanitize($('.registration-form input[name="user_job"]').val());

        // IF EMAIL IS INCORRECT
        if (!isValidEmailAddress(user_email)) {
            $('.registration-form input[name="user_email"]').addClass('error');
            message = "The email you have entered is invalid. Pleach check again.";
            $('.form-message-bad').text(message);
            $('.form-message-container').css('display', 'block');
            return
        }

        if ($('#licence-agreement').prop('checked') == false) {
            $('#licence-agreement-label').addClass('error');
            message = "You have to read and agree with our terms and conditions.";
            $('.form-message-bad').text(message);
            $('.form-message-container').css('display', 'block');
            return
        }


        $('#submit-registration-form').css('display', 'none');
        $('.registration-form .loader-container').css('display', 'block');

        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            dataType: "text",
            data: {
                action: "ajax_register_user",
                user_firstname: user_firstname,
                user_surname: user_surname,
                user_email: user_email,
                user_country: user_country,
                user_company: user_company,
                user_job: user_job,
            },
            success: function(result) {
                if (result == "User exists") {
                    $('.registration-form input[name="user_email"]').addClass('error');
                    message = "The email is already registered. <a href='#'>Login?</a>";
                    $('.form-message-bad').html(message);
                    $('.form-message-container').css('display', 'block');

                    $('#submit-registration-form').css('display', 'block');
                    $('.registration-form .loader-container').css('display', 'none');
                } else { // user doesn't egsist, validation email sent
                    var today = new Date().toJSON();

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'formSubmitSuccess',
                        timeStamp: today,
                        form_name: 'RegisterForm',
                        form_id: '11128',
                    });
                    $('.registration-form').css('display', 'none');
                    $('#validation-email-send-container').css('display', 'block');
                    $('#email-sent-message').html('Thank you for registering with RoyaltyRange. An email with instructions on how to continue the registration process has been sent to <strong>' + user_email + '</strong>');

                    $("html, body").animate({ scrollTop: 0 }, "fast");

                }

                $('#submit-registration-form').css('display', 'block');
                $('.registration-form .loader-container').css('display', 'none');

            },
            error: function(result) {}
        });

    });

    $("#submit-complete-registration-form").click(function(e) {
        var error = false;

        if (maintenance_enabled()) {
            e.preventDefault();
            $('.background-overlay').toggleClass('show');
            $('.maintanance-form').toggleClass('show');
            display_maintanance_form();
            return
        }

        if ($('#submit-registration-form .allow-send').val()) {
            return;
        }

        $('.registration-form .form-message-container').css('display', 'none');
        $('.registration-form .form-message-container p').text('');
        $('.registration-form input').removeClass('error');
        $('#licence-agreement-label').removeClass('error');
        var message = '';

        // IF REQUIRED FIELDS ARE EMPTY
        $('.registration-form .required').each(function(index) {
            if (!$(this).val()) {
                $(this).addClass('error');
                message = "You must fill all required fields.";
                $('.form-message-bad').text(message);
                $('.form-message-container').css('display', 'block');
                error = true;
            }
        });

        if (error) {
            return;
        }

        var user_firstname = sanitize($('.registration-form input[name="user_firstname"]').val());
        var user_surname = sanitize($('.registration-form input[name="user_surname"]').val());
        var user_email = sanitize($('.registration-form input[name="user_email"]').val());
        var user_country = sanitize($('.registration-form input[name="user_country"]').val());
        var user_company = sanitize($('.registration-form input[name="user_company"]').val());
        var user_job = sanitize($('.registration-form input[name="user_job"]').val());
        var user_password = sanitize($('.registration-form input[name="user_password"]').val());
        var user_password_repeat = sanitize($('.registration-form input[name="user_password_repeat"]').val());

        if (user_password != user_password_repeat) {
            $('.registration-form input[name="user_password"]').addClass('error');
            message = "Passwords do not match";
            $('.form-message-bad').text(message);
            $('.form-message-container').css('display', 'block');
            return
        }

        // IF EMAIL IS INCORRECT
        if (!isValidEmailAddress(user_email)) {
            $('.registration-form input[name="user_email"]').addClass('error');
            message = "The email you have entered is invalid. Pleach check again.";
            $('.form-message-bad').text(message);
            $('.form-message-container').css('display', 'block');
            return
        }

        if ($('#licence-agreement').prop('checked') == false) {
            $('#licence-agreement-label').addClass('error');
            message = "You have to read and agree with our terms and conditions.";
            $('.form-message-bad').text(message);
            $('.form-message-container').css('display', 'block');
            return
        }


        $('#submit-registration-form').css('display', 'none');
        $('.registration-form .loader-container').css('display', 'block');

        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            dataType: "text",
            data: {
                action: "ajax_complete_register_manual_user",
                user_firstname: user_firstname,
                user_surname: user_surname,
                user_email: user_email,
                user_country: user_country,
                user_company: user_company,
                user_job: user_job,
                user_password: user_password,
            },
            success: function(result) {
                $('input#user_login').val(user_email);
                $('input#user_pass').val(user_password);
                $('#loginpop-form').submit();
            },
            error: function(result) {}
        });

    });

    // When focused again, remove red border class
    $('.required').focus(function(e) {
        $(this).removeClass('error');
    });
    // $('.required-country .select-selected').click(function(e) {
    //     console.log('Focus country');
    //     $('.required-country').removeClass('error');
    // });
    $('input').focus(function(e) {
        $(this).removeClass('error');
    });


    // CONTACT US FORM SUBMITTED
    $(".contact-us-form #submit-contact-form").click(function() { //contact-form-submitted
        if ($('.allow-send').val()) { //if spam input is filled then terminate
            return;
        }

        var error = false;
        var message = '';

        $('.form-message-container').css('display', 'none');
        $('.form-message-container p').text('');
        $('.contact-us-form input').removeClass('error');

        $('.contact-us-form .required').each(function(index) {
            if (!$(this).val()) {
                $(this).addClass('error');
                error = true;
                message = "You must fill all required fields.";
            }
        });

        if (error) {
            $('.form-message-bad').text(message);
            $('.form-message-container').css('display', 'block');
            return
        }

        var user_email = sanitize($('.contact-us-form input[name="user_email"]').val());
        var user_name = sanitize($('.contact-us-form input[name="user_name"]').val());
        var user_company = sanitize($('.contact-us-form input[name="user_company"]').val());
        var user_message = sanitize($('.contact-us-form textarea[name="user_message"]').val());

        if (full_name_check(user_name) == false) {
            $('.contact-us-form input[name="user_name"]').addClass('error');

            $('.form-message-container').append('<p class="form-message-bad">Please enter your full name.</p>');
            $('.form-message-container').css('display', 'block');
            return;
        }

        if (!isValidEmailAddress(user_email)) {
            $('.contact-us-form input[name="user_email"]').addClass('error');
            error = true;
            message = "The email you have entered is invalid. Pleach check again.";
        }

        if (user_company != undefined && user_company != '') {
            if (!isValidCompanyName(user_company)) {
                $('.contact-us-form input[name="user_company"]').addClass('error');
                error = true;
                message = "The company name you have entered is invalid. Pleach check again.";
            }
        }

        // if (user_name != undefined && user_name != '') {
        //     if (!isValidFullName(user_name)) {
        //         $('.contact-us-form input[name="user_name"]').addClass('error');
        //         error = true;
        //         message = "Please enter your full name.";
        //     }
        // }

        if (error) {
            $('.form-message-bad').text(message);
            $('.form-message-container').css('display', 'block');
            return
        }

        // Hide button and show loader
        $(this).css('display', 'none');
        $('.loader-container').css('display', 'block');

        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            data: {
                action: "ajax_contact_us_mail",
                user_email: user_email,
                user_name: user_name,
                user_company: user_company,
                user_message: user_message
            },
            success: function(result) {
                // $('.contact-us-form #submit-contact-form').css('display','block');
                $('.contact-us-form .loader-container').css('display', 'none');

                var today = new Date().toJSON();

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'formSubmitSuccess',
                    timeStamp: today,
                    form_name: 'ContactUsForm',
                    form_id: '11124',
                });

                $('.contact-us-form input').val('');
                $('.contact-us-form textarea').val('');

                $('.form-message-good').text('Your message has been sent successfully!');
                $('.form-message-container').css('display', 'block');
            },
            error: function(result) {
                $('.contact-us-form #submit-contact-form').css('display', 'block');
                $('.contact-us-form .loader-container').css('display', 'none');

                $('.form-message-good').text('We are sorry, but an error occured while sending your message, please try again later.');
                $('.form-message-container').css('display', 'block');
            }
        });

    });


    function update_country_selector(region) {
        if (region == 'non-eu') {
            $(".vat-container").hide();

            $('.flag-dropdown .selected-flag').attr('title', 'United States');
            $('.flag-dropdown .selected-flag .flag').removeClass('gb');
            $('.flag-dropdown .selected-flag .flag').addClass('us');
            $(".country-select input").val('United States');

            $('.country-list li.country[data-country-code="us"]').addClass('active');
            $('.country-list li.country[data-country-code="gb"]').removeClass('active');

            // Hide all eu countries
            $(".country-list li.country").each(function(index) {
                var country_code = $(this).data('country-code');
                // console.log( $.inArray( country_code, eu_countries) );
                if ($.inArray(country_code, eu_countries) !== -1) {
                    $(this).css('display', 'none');
                } else {
                    $(this).css('display', 'list-item');
                }
            });
        }

        if (region == 'eu') {
            $(".vat-container").show();

            $('.flag-dropdown .selected-flag').attr('title', 'United Kingdom');
            $('.flag-dropdown .selected-flag .flag').removeClass('us');
            $('.flag-dropdown .selected-flag .flag').addClass('gb');
            $(".country-select input").val('United Kingdom');

            $('.country-list li.country[data-country-code="gb"]').addClass('active');
            $('.country-list li.country[data-country-code="us"]').removeClass('active');

            // Hide all noneu countries
            $(".country-list li.country").each(function(index) {
                var country_code = $(this).data('country-code');
                // console.log( $.inArray( country_code, eu_countries) );
                if ($.inArray(country_code, eu_countries) == -1) {
                    $(this).css('display', 'none');
                } else {
                    $(this).css('display', 'list-item');
                }
            });
        }

    }

    $('body').on('click', '#password-submit', function(e) {
        var error = false;

        // IF REQUIRED FIELDS ARE EMPTY
        $('#password-submit-form .required').each(function(index) {
            if (!$(this).val()) {
                $(this).addClass('error');
                message = "You must fill all required fields.";
                $('#password-submit-form .form-message-bad').text(message);
                $('#password-submit-form .form-message-container').css('display', 'block');
                error = true;
            }
        });

        if (error) {
            return;
        }

        $('#password-submit-form .form-message-container').css('display', 'none');
        $('#password-submit-form .form-message-container p').text('');
        $('#password-submit-form input').removeClass('error');


        var user_email = $('#password-submit-form').data('registration-email');
        var user_key = $('#password-submit-form').data('user-token');
        var user_password = $('#password-submit-form input[name="user_password"]').val();
        var user_password_repeat = $('#password-submit-form input[name="user_password_repeat"]').val();

        if (user_password != user_password_repeat) {
            $('#password-submit-form .form-message-container').css('display', 'block');
            $('#password-submit-form input').addClass('error');
            $('#password-submit-form .form-message-bad').html('Your passwords do not match.');
            var error = true;
        }

        if (error) {
            return;
        }


        $(this).css('display', 'none');
        $('.loader-container').css('display', 'block');

        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            data: {
                action: "ajax_password_submit",
                user_email: user_email,
                user_key: user_key,
                user_password: user_password,
            },
            success: function(result) {

                $('#password-submit-form').css('display', 'none');
                $('#page-login-form').css('display', 'block');

            },
            error: function(result) {
                answer = result;
            }
        });

    });


    // DISABLE LOGIN AND REQUEST WHEN MAINTANANCE
    // maintanance-disabled

    function hide_maintanance_form() {
        $('.maintanance-background').css('display', 'none');
        $('#maintanance-form').css('display', 'none');
    }

    function display_maintanance_form() {
        $('.maintanance-background').css('display', 'block');
        $('#maintanance-form').css('display', 'block');
    }


    $('body').on('click', '.register-linkedin', function(event) {
        var user_ip = $('body').data('user-ip');
        if (user_ip != '0' && user_ip != '88.216.165.55') {
            display_maintanance_form();
            event.preventDefault();
            return;
        }
    });

    $('body').on('click', '.linkedin-login-button', function(event) {
        var user_ip = $('body').data('user-ip');
        if (user_ip != '0' && user_ip != '88.216.165.55') {
            display_maintanance_form();
            event.preventDefault();
            return;
        }
    });

    $('body').on('click', '#request-wp-submit', function(event) {
        var user_ip = $('body').data('user-ip');
        if (user_ip != '0' && user_ip != '88.216.165.55') {
            display_maintanance_form();
            event.preventDefault();
            return;
        }
    });

    $('body').on('click', '.request-login-button.linkedin-login-button', function(event) {
        event.preventDefault();
    });


    $('body').on('click', '#close-maintanance-form', function() {
        hide_maintanance_form();
    });

    $('body').on('click', '.maintanancepwclose', function() {
        hide_maintanance_form();
    });

    $('body').on('click', '.maintanance-background', function() {
        hide_maintanance_form();
    });





    // READY MADE functions


    $('body').on('click', '#submit-one-search-purchase', function() {
        var error = false;
        var max_items_allowed = 3;

        $('#one-search-purchase-form .form-message-container').empty();
        $('#one-search-purchase-form .form-message-container').css('display', 'none');

        var client_region = $('[name="invoice-checkbox"]:checked').val();
        // check if reagion is chosen
        if (client_region !== 'euclient' && client_region !== 'noneuclient') {
            $('#one-search-purchase-form .form-message-container').append('<p class="form-message-bad">You must choose region option.</p>');
            $('#one-search-purchase-form .form-message-container').css('display', 'block');
            $(".vat-radio").css('border-color', '#b71c1c');
            return;
        }

        // Check if country complies with region:
        var selected_country = $('.country-list .country.active').data('country-code');
        var in_eu = true;

        if ($.inArray(selected_country, eu_countries) == -1) {
            in_eu = false;
        }

        if ((in_eu === false && client_region == 'euclient') || (in_eu === true && client_region == 'noneuclient')) {
            $('#one-search-purchase-form .form-message-container').append('<p class="form-message-bad">Selected country and region do not match.</p>');
            $('#one-search-purchase-form .form-message-container').css('display', 'block');
            $('.country-select input').css('border-color', '#b71c1c');
            return;
        }



        $("#one-search-purchase-form input.required").each(function(index) {
            if (!$(this).val()) {
                $(this).addClass('error');
                error = true;
            }
        });

        if (error) {
            $('#one-search-purchase-form .form-message-container').append('<p class="form-message-bad">You must fill all required fields.</p>');
            $('#one-search-purchase-form .form-message-container').css('display', 'block');
            return;
        }



        var user_currency = 'USD';
        var singleOneSearchPrice = $('#one-search-purchase-form').data('usd-price');
        if ($('html').hasClass('user-currency-eur')) {
            user_currency = 'EUR';
            singleOneSearchPrice = $('#one-search-purchase-form').data('eur-price');
        }

        var user_vat = $('#one-search-purchase-form #vat-value').data('vat');

        var user_name = sanitize($('#one-search-purchase-form input[name="user_name"]').val());
        var user_email = sanitize($('#one-search-purchase-form input[name="user_email"]').val());
        var user_company = sanitize($('#one-search-purchase-form input[name="company_name"]').val());
        var user_files = sanitize($('#one-search-purchase-form').data('order-files'));

        var user_amount = $('#one-search-purchase-form').data('order-price');
        var invoice_status = $('#one-search-purchase-form #invoice-checkbox').prop('checked');
        var invoice_country = clean_country_name($('#one-search-purchase-form .selected-flag').attr("title"));
        var invoice_address = sanitize($('#one-search-purchase-form input[name="company_address"]').val());
        var invoice_vatno = sanitize($('#one-search-purchase-form input[name="vat_number"]').val());

        if (full_name_check(user_name) == false) {
            $('#one-search-purchase-form input[name="user_name"]').addClass('error');

            $('#one-search-purchase-form .form-message-container').append('<p class="form-message-bad">Please enter your full name.</p>');
            $('#one-search-purchase-form .form-message-container').css('display', 'block');
            return;
        }

        if (invoice_status && invoice_vatno != '') {
            if (!$('#one-search-ready-made-form .vat_number').hasClass('vat-valid')) {
                $('#one-search-purchase-form .form-message-container').append('<p class="form-message-bad">Vat number is incorrect.</p>');
                $('#one-search-ready-made-form .vat_number').addClass("error");
                $('#one-search-purchase-form .form-message-container').css('display', 'block');

                return;
            }
        }

        var user_country = $('#one-search-purchase-form .flag-dropdown .selected-flag').attr("title");
        user_country = user_country.substr(0, user_country.indexOf(':')); // Remove prefix

        if (user_country.indexOf("(") >= 0) {
            user_country = user_country.substr(0, user_country.indexOf('(')); // Remove native name
        }
        var prefix = $('#one-search-purchase-form .flag-dropdown .selected-flag').attr("title");
        prefix = prefix.substr(prefix.indexOf(':') + 2);

        if (!user_email) {
            $('#one-search-purchase-form input[name="user_email"]').addClass('error');
            error = true;
        } else if (!isValidEmailAddress(user_email)) {
            $('#one-search-purchase-form input[name="user_email"]').addClass('error');
            $('#one-search-purchase-form .form-message-container').append('<p class="form-message-bad">The email is incorrect.</p>');
            $('#one-search-purchase-form .form-message-container').css('display', 'block');
            error = true;
        }
        if (user_files === "") {
            $('#one-search-purchase-form .form-message-container').append('<p class="form-message-bad">No One Searches selected.</p>');
            $('#one-search-purchase-form .form-message-container').css('display', 'block');
            error = true;
        } else if (user_files.split(',').length > max_items_allowed) {
            $('#one-search-purchase-form .form-message-container').append('<p class="form-message-bad">Only ' + max_items_allowed + ' reports are allowed to purchase at once.</p>');
            $('#one-search-purchase-form .form-message-container').css('display', 'block');
            error = true;
        }

        if (error) {
            return;
        }


        var landing_page_info = '';

        if ($("#primary").hasClass("custom-landing-page")) {
            var main_keyword = $("#primary").data('main-key-word');
            var page_url = $(location).attr("href");
            landing_page_info = "Page keyword: " + main_keyword + ". Landing page: " + page_url;
        }


        $(this).css('display', 'none');
        $('#one-search-purchase-form .loader-container').css('display', 'block');

        $('#one-search-ready-made-form select.select-box-original')[0].sumo.disable();
        $('#one-search-ready-made-form .SumoSelectOriginal.disabled li.opt').addClass('disabled-inputs');
        $('#one-search-ready-made-form #selected-one-search .remove-topic').addClass('disabled-inputs');
        $('#one-search-ready-made-form .invoice-checkbox-container label').addClass('disabled-inputs');
        $('#one-search-ready-made-form .selected-flag').addClass('disabled-inputs');
        $('#one-search-ready-made-form .country-select input').addClass('disabled-inputs');
        $('#one-search-ready-made-form .company_address').addClass('disabled-inputs');
        $('#one-search-ready-made-form .vat_number').addClass('disabled-inputs');
        $('#one-search-ready-made-form #one-search-purchase-form input').prop('readonly', 'readonly');

        var gclid = get_google_ad_click_id();

        var vat_valid = 'false';

        if ($('#one-search-ready-made-form .vat_number').hasClass('vat-valid')) {
            vat_valid = 'true';
        }

        var form = '<form style="display:none" id="ready_made_one_search_form" class="" action="/home/payment" method="post">' +
            '<input type="hidden" name="payment_type" value="ready_made_one_search">' +
            '<input type="hidden" name="client_name" value="' + user_name + '">' +
            '<input type="hidden" name="user_company" value="' + user_company + '">' +
            '<input type="hidden" name="request_email" value="' + user_email + '">' +
            '<input type="hidden" name="landing_page_info" value="' + landing_page_info + '">' +
            '<input type="hidden" name="request_price" value="' + user_amount + '">' +
            '<input type="hidden" name="request_vat" value="' + user_vat + '">' +
            '<input type="hidden" name="vat_valid" value="' + vat_valid + '">' +
            '<input type="hidden" name="request_files" value="' + user_files + '">' +
            '<input type="hidden" name="request_currency" value="' + user_currency + '">' +
            '<input type="hidden" name="invoice_status" value="' + invoice_status + '">' +
            '<input type="hidden" name="invoice_country" value="' + invoice_country + '">' +
            '<input type="hidden" name="invoice_address" value="' + invoice_address + '">' +
            '<input type="hidden" name="invoice_vatno" value="' + invoice_vatno + '">' +
            '<input type="hidden" name="gclid" value="' + gclid + '">' +
            '<input type="submit" value="submit" >' +
            '</form>';

        $(this).after(form);
        var event_name = "ReadyMadeOneSearchLead";
        var currency = user_currency;
        var name = "Ready Made One Search";
        var id = 11120;
        var category = "Ready Made";
        var database = "";
        var subscription_plan = "";
        var variant = "";

        var today = new Date().toJSON();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'formSubmitSuccess',
            timeStamp: today,
            form_name: event_name,
            form_id: id,
            ecommerce: {
                currencyCode: currency,
                purchase: [{
                    products: [{
                        name: name, // Product name
                        id: id, // product ID
                        // price: '500',  // product price
                        category: category, // Product category
                        database: database,
                        plan: subscription_plan,
                        variant: variant // write-up option
                    }]
                }]
            }
        });

        bing_lead_conversion();

        $("#ready_made_one_search_form").submit();

    });


    $('body').on('click', '#submit-benchmarking-study-purchase', function() {
        var error = false;
        var max_items_allowed = 3;

        $('#benchmarking-ready-made-form .form-message-container').empty();
        $('#benchmarking-ready-made-form .form-message-container').css('display', 'none');

        var client_region = $('[name="invoice-checkbox"]:checked').val();
        // check if reagion is chosen
        if (client_region !== 'euclient' && client_region !== 'noneuclient') {
            $('#benchmarking-ready-made-form .form-message-container').append('<p class="form-message-bad">You must choose region option.</p>');
            $('#benchmarking-ready-made-form .form-message-container').css('display', 'block');
            $(".vat-radio").css('border-color', '#b71c1c');
            return;
        }

        // Check if country complies with region:
        var selected_country = $('.country-list .country.active').data('country-code');
        var in_eu = true;

        if ($.inArray(selected_country, eu_countries) == -1) {
            in_eu = false;
        }

        if ((in_eu === false && client_region == 'euclient') || (in_eu === true && client_region == 'noneuclient')) {
            $('#benchmarking-ready-made-form .form-message-container').append('<p class="form-message-bad">Selected country and region do not match.</p>');
            $('#benchmarking-ready-made-form .form-message-container').css('display', 'block');
            $('.country-select input').css('border-color', '#b71c1c');
            return;
        }

        $("#benchmarking-ready-made-form .bechmarking-purchase-form input.required").each(function(index) {
            if (!$(this).val()) {
                $(this).addClass('error');
                // console.log($(this));
                error = true;
            }
        });


        if (error) {
            $('#benchmarking-ready-made-form .form-message-container').append('<p class="form-message-bad">You must fill all required fields.</p>');
            $('#benchmarking-ready-made-form .form-message-container').css('display', 'block');
            return;
        }

        var user_currency = 'USD';
        var singleBenchmarkPrice = $('#benchmarking-purchase-form').data('usd-price');
        if ($('html').hasClass('user-currency-eur')) {
            user_currency = 'EUR';
            singleBenchmarkPrice = $('#benchmarking-purchase-form').data('eur-price');
        }

        var user_vat = $('#benchmarking-ready-made-form #vat-value').data('vat');

        var user_name = sanitize($('.bechmarking-purchase-form input[name="user_name"]').val());
        var user_email = sanitize($('.bechmarking-purchase-form input[name="user_email"]').val());
        var user_company = sanitize($('.bechmarking-purchase-form input[name="user_company"]').val());

        var user_files = sanitize($('.bechmarking-purchase-form').data('order-files'));

        var _files = user_files.split(',');
        var files_count = _files.length;
        var user_amount = $('#benchmarking-purchase-form').data('order-price');
        var invoice_status = $('#benchmarking-ready-made-form #invoice-checkbox').prop('checked');
        var invoice_country = clean_country_name($('#benchmarking-ready-made-form .selected-flag').attr("title"));
        var invoice_address = sanitize($('.bechmarking-purchase-form input[name="company_address"]').val());
        var invoice_vatno = sanitize($('.bechmarking-purchase-form input[name="vat_number"]').val());


        if (full_name_check(user_name) == false) {
            $('.bechmarking-purchase-form input[name="user_name"]').addClass('error');

            $('.bechmarking-purchase-form .form-message-container').append('<p class="form-message-bad">Please enter your full name.</p>');
            $('.bechmarking-purchase-form .form-message-container').css('display', 'block');
            return;
        }

        if (invoice_status && invoice_vatno != '') {
            if (!$('#benchmarking-ready-made-form .vat_number').hasClass('vat-valid')) {
                $('.bechmarking-purchase-form .form-message-container').append('<p class="form-message-bad">Vat number is incorrect.</p>');
                $('#benchmarking-ready-made-form .vat_number').addClass("error");
                $('.bechmarking-purchase-form .form-message-container').css('display', 'block');

                return;
            }
        }

        var user_country = $('#benchmarking-purchase-form .flag-dropdown .selected-flag').attr("title");
        user_country = user_country.substr(0, user_country.indexOf(':')); // Remove prefix

        if (user_country.indexOf("(") >= 0) {
            user_country = user_country.substr(0, user_country.indexOf('(')); // Remove native name
        }

        var prefix = $('#benchmarking-purchase-form .flag-dropdown .selected-flag').attr("title");
        prefix = prefix.substr(prefix.indexOf(':') + 2);

        if (!user_email) {
            $('.bechmarking-purchase-form input[name="user_email"]').addClass('error');
            error = true;
        } else if (!isValidEmailAddress(user_email)) {
            $('.bechmarking-purchase-form input[name="user_email"]').addClass('error');
            $('#benchmarking-ready-made-form .form-message-container').append('<p class="form-message-bad">The email is incorrect.</p>');
            $('#benchmarking-ready-made-form .form-message-container').css('display', 'block');
            error = true;
        }

        if (user_files === "") {
            $('#benchmarking-ready-made-form .form-message-container').append('<p class="form-message-bad">No benchmarks selected.</p>');
            $('#benchmarking-ready-made-form .form-message-container').css('display', 'block');
            error = true;
        } else if (user_files.split(',').length > max_items_allowed) {
            $('#one-search-purchase-form .form-message-container').append('<p class="form-message-bad">Only ' + max_items_allowed + ' reports are allowed to purchase at once.</p>');
            $('#one-search-purchase-form .form-message-container').css('display', 'block');
            error = true;
        }

        if (error) {
            return;
        }

        landing_page_info = "";

        if ($("#primary").hasClass("custom-landing-page")) {
            var main_keyword = $("#primary").data('main-key-word');
            var page_url = $(location).attr("href");
            landing_page_info = "Page keyword: " + main_keyword + ". Landing page: " + page_url;
        }

        $(this).css('display', 'none');
        $('.bechmarking-purchase-form .loader-container').css('display', 'block');

        $('#benchmarking-ready-made-form select.select-box-original')[0].sumo.disable();
        $('#benchmarking-ready-made-form .SumoSelectOriginal.disabled li.opt').addClass('disabled-inputs');
        $('#benchmarking-ready-made-form #selected-benchmarks .remove-topic').addClass('disabled-inputs');
        $('#benchmarking-ready-made-form .invoice-checkbox-container label').addClass('disabled-inputs');
        $('#benchmarking-ready-made-form .selected-flag').addClass('disabled-inputs');
        $('#benchmarking-ready-made-form .country-select input').addClass('disabled-inputs');
        $('#benchmarking-ready-made-form .company_address').addClass('disabled-inputs');
        $('#benchmarking-ready-made-form .vat_number').addClass('disabled-inputs');
        $('#benchmarking-ready-made-form #benchmarking-purchase-form input').prop('readonly', 'readonly');

        var gclid = get_google_ad_click_id();

        var vat_valid = 'false';

        if ($('#benchmarking-ready-made-form .vat_number').hasClass('vat-valid')) {
            vat_valid = 'true';
        }

        var form = '<form style="display:none" id="ready_made_benchmarking_form" class="" action="/home/payment" method="post">' +
            '<input type="hidden" name="payment_type" value="ready_made_benchmarking">' +
            '<input type="hidden" name="client_name" value="' + user_name + '">' +
            '<input type="hidden" name="user_company" value="' + user_company + '">' +
            '<input type="hidden" name="request_email" value="' + user_email + '">' +
            '<input type="hidden" name="landing_page_info" value="' + landing_page_info + '">' +
            '<input type="hidden" name="request_price" value="' + user_amount + '">' +
            '<input type="hidden" name="request_vat" value="' + user_vat + '">' +
            '<input type="hidden" name="vat_valid" value="' + vat_valid + '">' +
            '<input type="hidden" name="request_files" value="' + user_files + '">' +
            '<input type="hidden" name="request_currency" value="' + user_currency + '">' +
            '<input type="hidden" name="invoice_status" value="' + invoice_status + '">' +
            '<input type="hidden" name="invoice_country" value="' + invoice_country + '">' +
            '<input type="hidden" name="invoice_address" value="' + invoice_address + '">' +
            '<input type="hidden" name="invoice_vatno" value="' + invoice_vatno + '">' +
            '<input type="hidden" name="gclid" value="' + gclid + '">' +
            '<input type="submit" value="submit" >' +
            '</form>';

        $(this).after(form);
        var event_name = "ReadyMadeBenchmarkingLead";
        var currency = user_currency;
        var name = "Ready Made Benchmarking";
        var id = 11121;
        var category = "Ready Made";
        var database = "";
        var subscription_plan = "";
        var variant = "";

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: event_name,
            ecommerce: {
                currencyCode: currency,
                purchase: [{
                    products: [{
                        name: name, // Product name
                        id: id, // product ID
                        // price: '500',  // product price
                        category: category, // Product category
                        database: database,
                        plan: subscription_plan,
                        variant: variant // write-up option
                    }]
                }]
            }
        });

        bing_lead_conversion();

        $("#ready_made_benchmarking_form").submit();

    });



    $('.site-content-container').on('change', '#one-search-ready-made-form [name="invoice-checkbox"]', function(e) {
        $('.vat-radio').css('border-color', '#c9d7df');
        $('#one-search-ready-made-form .vat_number').removeClass('vat-valid');

        if (this.checked) {
            $('#one-search-ready-made-form #invoice-fields').addClass('show');
            $('#one-search-ready-made-form .company_address').addClass('required');

            // non eu client
            if ($(this).val() == "noneuclient") {

                update_country_selector('non-eu');
                $(".vat-amount").css('display', 'none');
                $(".price-before-vat").css('display', 'none');
                // eu client
            } else {
                one_search_validate_vat();
                update_country_selector('eu');
                $(".vat-amount").css('display', 'block');
                $(".price-before-vat").css('display', 'block');

            }

            one_search_vat_by_country();
            calculate_final_one_search_price();

        }
    });


    $('.site-content-container').on('change', '#benchmarking-ready-made-form [name="invoice-checkbox"]', function(e) {

        $('.vat-radio').css('border-color', '#c9d7df');
        $('#benchmarking-ready-made-form .vat_number').removeClass('vat-valid');

        if (this.checked) {
            $('#benchmarking-ready-made-form #invoice-fields').addClass('show');
            $('#benchmarking-ready-made-form .company_address').addClass('required');

            // non eu client
            if ($(this).val() == "noneuclient") {

                update_country_selector('non-eu');
                $(".vat-amount").css('display', 'none');
                $(".price-before-vat").css('display', 'none');
                // eu client
            } else {
                benchmarking_validate_vat();
                update_country_selector('eu');
                $(".vat-amount").css('display', 'block');
                $(".price-before-vat").css('display', 'block');

            }

            benchmarking_vat_by_country();
            calculate_final_benchmarking_price();

        }

    });


    $('#one-search-ready-made-form #one-search-country').on('change', function() {
        one_search_vat_by_country();
    });

    $('#benchmarking-ready-made-form #benchmarking_country').on('change', function() {
        benchmarking_vat_by_country();
    });


    function one_search_vat_by_country(countryCode) {
        if (countryCode === undefined) {
            var countryCode = $("#one-search-ready-made-form .country.active").data('country-code').toUpperCase();
        }

        if (countryCode === 'GB') {
            $('#one-search-ready-made-form #vat-value').text(20);
            $('#one-search-ready-made-form #vat-value').data('vat', 20);
        } else {
            $('#one-search-ready-made-form #vat-value').text(0);
            $('#one-search-ready-made-form #vat-value').data('vat', 0);
            // $('#one-search-ready-made-form #vat-value').text(vatRates[countryCode]);
            // $('#one-search-ready-made-form #vat-value').data('vat',vatRates[countryCode]);
        }

        // if ($('#one-search-ready-made-form #vat-value').data('vat-no') === 1) {
        //     $('#one-search-ready-made-form #vat-value').text('0');
        //     $('#one-search-ready-made-form #vat-value').data('vat',0);
        // }

        calculate_final_one_search_price();
    }


    function benchmarking_vat_by_country(countryCode) {
        if (countryCode === undefined) {
            var countryCode = $("#benchmarking-ready-made-form .country.active").data('country-code').toUpperCase();
        }

        if (countryCode === 'GB') {
            $('#benchmarking-ready-made-form #vat-value').text(20);
            $('#benchmarking-ready-made-form #vat-value').data('vat', 20);
        } else {
            $('#benchmarking-ready-made-form #vat-value').text(0);
            $('#benchmarking-ready-made-form #vat-value').data('vat', 0);
        }

        // if (vatRates.hasOwnProperty(countryCode)) {
        //     $('#benchmarking-ready-made-form #vat-value').text(vatRates[countryCode]);
        //     $('#benchmarking-ready-made-form #vat-value').data('vat',vatRates[countryCode]);
        // } else {
        //     $('#benchmarking-ready-made-form #vat-value').text(vatRates['default']);
        //     $('#benchmarking-ready-made-form #vat-value').data('vat',vatRates['default']);
        // }
        // if ($('#benchmarking-ready-made-form #vat-value').data('vat-no') === 1) {
        //     $('#benchmarking-ready-made-form #vat-value').text('0');
        //     $('#benchmarking-ready-made-form #vat-value').data('vat',0);
        // }

        calculate_final_benchmarking_price();
    }




    //RUN ONE SEARCH VAT CHECKER
    var one_search_typingTimer; //timer identifier
    var one_search_doneTypingInterval = 1000; //time in ms, 5 second for example
    var one_search_input = $('#one-search-ready-made-form input.vat_number');

    //on keyup, start the countdown
    $('.site-content-container').on("keyup", "#one-search-ready-made-form input.vat_number", function() {
        // one_search_input.on('keyup', function () {
        clearTimeout(one_search_typingTimer);
        one_search_typingTimer = setTimeout(one_search_doneTyping, one_search_doneTypingInterval);
    });

    //on keydown, clear the countdown
    $('.site-content-container').on("keydown", "#one-search-ready-made-form input.vat_number", function() {
        // one_search_input.on('keydown', function () {
        clearTimeout(one_search_typingTimer);
    });

    //user is "finished typing," do something
    function one_search_doneTyping() {
        one_search_validate_vat();
    }

    // VAT VALIDATION
    function one_search_validate_vat() {
        var vatNo = $("#one-search-ready-made-form .vat_number").val();
        var countryCode = $("#one-search-ready-made-form .country.active").data('country-code').toUpperCase();
        $('.vat-loader svg').css('display', 'block');

        // Old ajax VAT code validity checker

        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            data: {
                action: "validate_vat",
                vat: vatNo,
            },
            success: function(result) {
                console.log('result');
                console.log(result);
                console.log('post result');
                // if vat invalid
                if (result == '' || result == ' ' || result == 'error' || result == 'No vat number provided' || result == ' error' || result == ' No vat number provided') {
                    $('.vat-validation-message').html('Please provide VAT number if applicable');
                    console.log('Please provide VAT number');

                    // if (countryCode === 'GB'){
                    //     $('#one-search-ready-made-form #vat-value').data('vat-no', 0);
                    //     $('#one-search-ready-made-form #vat-value').text('20');
                    //     $('#one-search-ready-made-form #vat-value').data('vat',20);
                    // }else{
                    //     $('#one-search-ready-made-form #vat-value').data('vat-no',0);
                    //     $('#one-search-ready-made-form #vat-value').text('0');
                    //     $('#one-search-ready-made-form #vat-value').data('vat',0);
                    // }

                    // one_search_vat_by_country();
                    calculate_final_one_search_price();
                    $('#one-search-ready-made-form .vat_number').removeClass('vat-valid');
                } else {
                    data = $.parseJSON(result);
                    if (data.valid === true) {
                        $('.vat-validation-message').html('VAT number is valid');
                        console.log(data.countryCode);
                        console.log(data.vatNumber);
                        console.log(data.name);
                        console.log(data.address);
                        // one_search_vat_by_country(data.countryCode);
                        $('#one-search-ready-made-form .vat_number').addClass('vat-valid');
                        calculate_final_one_search_price();
                    } else {
                        console.log('It seems the VAT number you provided is not valid');
                        $('.vat-validation-message').html('It seems the VAT number you provided is not valid');
                        // if (countryCode === 'GB'){
                        //     $('#one-search-ready-made-form #vat-value').data('vat-no', 0);
                        //     $('#one-search-ready-made-form #vat-value').text('20');
                        //     $('#one-search-ready-made-form #vat-value').data('vat',20);
                        // }else{
                        //     $('#one-search-ready-made-form #vat-value').data('vat-no',0);
                        //     $('#one-search-ready-made-form #vat-value').text('0');
                        //     $('#one-search-ready-made-form #vat-value').data('vat',0);
                        // }
                        calculate_final_one_search_price();
                        $('#one-search-ready-made-form .vat_number').removeClass('vat-valid');
                    }
                }
                $('.vat-loader svg').css('display', 'none');
            },
            error: function(result) {
                console.log('Error');
                $('#one-search-ready-made-form #vat-value').data('vat-no', 0);
                calculate_final_one_search_price();
                $('#one-search-ready-made-form .vat_number').removeClass('vat-valid');
                $('.vat-loader svg').css('display', 'none');
            }
        });

        // If VAT is alphanumeric and longer than 8 symbols
        //
        // if ( /\d/.test(vatNo) && /[a-zA-Z]/.test(vatNo) && vatNo.length > 8){
        //
        //     // Is valid alphanumeric VAT code
        //
        //     $('#one-search-ready-made-form .vat_number').addClass('vat-valid');
        //     $('.vat-validation-message').html('VAT is code valid');
        //     $('.vat-validation-message').css('color','#00a019');
        //
        //     $('#one-search-ready-made-form #vat-value').data('vat-no', vatNo);
        //
        //     if (countryCode != "GB"){
        //         $('#one-search-ready-made-form #vat-value').text('0');
        //         $('#one-search-ready-made-form #vat-value').data('vat', 0);
        //     }
        //
        //     calculate_final_one_search_price();
        //
        // }else{
        //
        //     // If not VAT code
        //
        //     $('#one-search-ready-made-form .vat_number').removeClass('vat-valid');
        //     $('.vat-validation-message').html('VAT code is not valid');
        //     $('.vat-validation-message').css('color','#b71c1c');
        //
        //     one_search_vat_by_country();
        //
        //     // calculate_final_one_search_price();
        // }


    }

    //RUN BENCHMARKING VAT CHECKER
    var benchmarking_typingTimer; //timer identifier
    var benchmarking_doneTypingInterval = 1000; //time in ms, 5 second for example
    var benchmarking_input = $('#benchmarking-ready-made-form input.vat_number');

    //on keyup, start the countdown
    $('.site-content-container').on('keyup', '#benchmarking-ready-made-form input.vat_number', function() {
        // benchmarking_input.on('keyup', function () {
        clearTimeout(benchmarking_typingTimer);
        benchmarking_typingTimer = setTimeout(benchmarking_doneTyping, benchmarking_doneTypingInterval);
    });

    //on keydown, clear the countdown
    $('.site-content-container').on('keydown', '#benchmarking-ready-made-form input.vat_number', function() {
        // benchmarking_input.on('keydown', function () {
        clearTimeout(benchmarking_typingTimer);
    });

    //user is "finished typing," do something
    function benchmarking_doneTyping() {
        benchmarking_validate_vat();
    }

    // VAT VALIDATION
    function benchmarking_validate_vat() {
        var vatNo = $("#benchmarking-ready-made-form .vat_number").val();
        var countryCode = $("#benchmarking-ready-made-form .country.active").data('country-code').toUpperCase();
        $('.vat-loader svg').css('display', 'block');
        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            data: {
                action: "validate_vat",
                vat: vatNo,
            },
            success: function(result) {

                if (result == '' || result == ' ' || result == 'error' || result == 'No vat number provided' || result == ' error' || result == ' No vat number provided') {
                    $('.vat-validation-message').html('Please provide VAT number if applicable');
                    // if (countryCode === 'GB'){
                    //     $('#benchmarking-ready-made-form #vat-value').data('vat-no',0);
                    //     $('#benchmarking-ready-made-form #vat-value').text('20');
                    //     $('#benchmarking-ready-made-form #vat-value').data('vat',20);
                    // }else{
                    //     $('#benchmarking-ready-made-form #vat-value').data('vat-no',0);
                    //     $('#benchmarking-ready-made-form #vat-value').text('0');
                    //     $('#benchmarking-ready-made-form #vat-value').data('vat',0);
                    // }
                    calculate_final_benchmarking_price();
                    $('#benchmarking-ready-made-form .vat_number').removeClass('vat-valid');
                    console.log('Please provide VAT number');
                } else {
                    data = $.parseJSON(result);
                    if (data.valid === true) {
                        console.log(data.countryCode);
                        console.log(data.vatNumber);
                        console.log(data.name);
                        console.log(data.address);
                        // benchmarking_vat_by_country(data.countryCode);
                        $('#benchmarking-ready-made-form .vat_number').addClass('vat-valid');
                        $('.vat-validation-message').html('VAT number is valid');
                        calculate_final_benchmarking_price();
                    } else {
                        console.log('It seems the VAT number you provided is not valid');
                        $('.vat-validation-message').html('It seems the VAT number you provided is not valid');
                        // if (countryCode === 'GB'){
                        //     $('#benchmarking-ready-made-form #vat-value').data('vat-no',0);
                        //     $('#benchmarking-ready-made-form #vat-value').text('20');
                        //     $('#benchmarking-ready-made-form #vat-value').data('vat',20);
                        // }else{
                        //     $('#benchmarking-ready-made-form #vat-value').data('vat-no',0);
                        //     $('#benchmarking-ready-made-form #vat-value').text('0');
                        //     $('#benchmarking-ready-made-form #vat-value').data('vat',0);
                        // }
                        calculate_final_benchmarking_price();
                        $('#benchmarking-ready-made-form .vat_number').removeClass('vat-valid');
                    }
                }
                $('.vat-loader svg').css('display', 'none');
            },
            error: function(result) {

                console.log('Error');
                $('#benchmarking-ready-made-form #vat-value').data('vat-no', 0);
                calculate_final_benchmarking_price();
                $('#benchmarking-ready-made-form .vat_number').removeClass('vat-valid');
                $('.vat-loader svg').css('display', 'none');
            }
        });

        // If VAT is alphanumeric and longer than 8 symbols

        // if ( /\d/.test(vatNo) && /[a-zA-Z]/.test(vatNo) && vatNo.length > 8){
        //
        //     // Is valid alphanumeric VAT code
        //
        //     $('#benchmarking-ready-made-form .vat_number').addClass('vat-valid');
        //     $('.vat-validation-message').html('VAT is code valid');
        //     $('.vat-validation-message').css('color','#00a019');
        //
        //     $('#benchmarking-ready-made-form #vat-value').data('vat-no', vatNo);
        //
        //     if (countryCode != "GB"){
        //         $('#benchmarking-ready-made-form #vat-value').text('0');
        //         $('#benchmarking-ready-made-form #vat-value').data('vat', 0);
        //     }
        //
        //     calculate_final_benchmarking_price();
        //
        // }else{
        //
        //     // If not VAT code
        //
        //     $('#benchmarking-ready-made-form .vat_number').removeClass('vat-valid');
        //     $('.vat-validation-message').html('VAT code is not valid');
        //     $('.vat-validation-message').css('color','#b71c1c');
        //
        //     benchmarking_vat_by_country();
        //     // calculate_final_benchmarking_price();
        // }


    }

    // PERCENTAGE AND FINAL PRICE CALCULATION
    function calculate_final_one_search_price() {
        var primaryPrice = $('#one-search-purchase-form').data('primary-price');
        var vatPercentage = $('#one-search-ready-made-form #vat-value').data('vat');
        var vatAmmount = primaryPrice * vatPercentage / 100;
        var totalAmmount = primaryPrice + vatAmmount;
        $('#one-search-purchase-form').data('order-price', totalAmmount);
        vatAmmount = (parseFloat(vatAmmount) / 100).toFixed(2);
        totalAmmount = (parseFloat(totalAmmount) / 100).toFixed(2);
        $('#one-search-ready-made-form #vat-amount').text(vatAmmount);
        $('#one-search-ready-made-form #total-price').text(totalAmmount);
    }

    function calculate_final_benchmarking_price() {
        var primaryPrice = $('#benchmarking-purchase-form').data('primary-price');
        var vatPercentage = $('#benchmarking-ready-made-form #vat-value').data('vat');
        var vatAmmount = primaryPrice * vatPercentage / 100;
        var totalAmmount = primaryPrice + vatAmmount;
        $('#benchmarking-purchase-form').data('order-price', totalAmmount);
        vatAmmount = (parseFloat(vatAmmount) / 100).toFixed(2);
        totalAmmount = (parseFloat(totalAmmount) / 100).toFixed(2);
        $('#benchmarking-ready-made-form #vat-amount').text(vatAmmount);
        $('#benchmarking-ready-made-form #total-price').text(totalAmmount);
    }




    // FREE LICENCE AGREEMENT REQUEST
    $('body').on('click', '#submit-licence-agreements-request', function() {
        var error = false;

        $('.form-message-container').empty();
        $('.form-message-container').css('display', 'none');

        $(".bechmarking-purchase-form input.required").each(function(index) {
            if (!$(this).val()) {
                $(this).addClass('error');
                error = true;
            }
        });

        if (error) {
            $('.form-message-container').append('<p class="form-message-bad">You must fill all required fields.</p>');
            $('.form-message-container').css('display', 'block');
            return;
        }

        var user_name = sanitize($('.bechmarking-purchase-form input[name="user_name"]').val());
        var user_email = sanitize($('.bechmarking-purchase-form input[name="user_email"]').val());
        var user_files = sanitize($('.bechmarking-purchase-form').data('order-files'));
        var user_phone = sanitize($('#benchmarking-purchase-form input[name="user_phone"]').val());
        var user_country = $('#benchmarking-purchase-form .flag-container .selected-flag').attr("title");
        var user_company = sanitize($('#benchmarking-purchase-form input[name="user_company"]').val());

        if (full_name_check(user_name) == false) {
            $('.bechmarking-purchase-form input[name="user_name"]').addClass('error');

            $('.form-message-container').append('<p class="form-message-bad">Please enter your full name.</p>');
            $('.form-message-container').css('display', 'block');
            return;
        }

        if (user_phone && user_phone.length > 6) {
            user_country = user_country.substr(0, user_country.indexOf(':')); // Remove prefix

            if (user_country.indexOf("(") >= 0) {
                user_country = user_country.substr(0, user_country.indexOf('(')); // Remove native name
            }

        } else {
            user_phone = '';
            user_country = '';
        }

        if (!user_email) {
            $('.bechmarking-purchase-form input[name="user_email"]').addClass('error');
            error = true;
        } else if (!isValidEmailAddress(user_email)) {
            $('.bechmarking-purchase-form input[name="user_email"]').addClass('error');
            $('.form-message-container').append('<p class="form-message-bad">The email is incorrect.</p>');
            $('.form-message-container').css('display', 'block');
            error = true;
        }

        if (user_files === "") {
            $('.form-message-container').append('<p class="form-message-bad">No licence agreements selected.</p>');
            $('.form-message-container').css('display', 'block');
            error = true;
        }

        if (error) {
            return;
        }

        $(this).css('display', 'none');
        $('.bechmarking-purchase-form .loader-container').css('display', 'block');

        $('select.select-box-original')[0].sumo.disable();
        $('.SumoSelectOriginal.disabled li.opt').addClass('disabled-inputs');
        $('#selected-benchmarks .remove-topic').addClass('disabled-inputs');
        $('#benchmarking-purchase-form input').prop('readonly', 'readonly');

        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            data: {
                action: "ajax_licence_agreements_request_submit",
                user_name: user_name,
                user_email: user_email,
                user_files: user_files,
                user_phone: user_phone,
                user_country: user_country,
                user_company: user_company,
            },
            success: function(result) {
                $(this).css('display', 'block');
                $('.bechmarking-purchase-form .loader-container').css('display', 'none');

                if (result == 'error') {
                    $('.form-message-container').append('<p class="form-message-bad">An error occured while sending your email. Please try again later.</p>');
                    $('.form-message-container').css('display', 'block');
                } else {

                    // send event information to google analytics
                    // if (typeof dataLayer !== 'undefined') {
                    //     dataLayer.push({ 
                    //         'event': 'formSubmitSuccess', 
                    //         'formName': 'LicenceAgreementExampleRequest',
                    //     });
                    // }
                    var today = new Date().toJSON();

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'formSubmitSuccess',
                        timeStamp: today,
                        form_name: 'LicenceAgreementExampleRequest',
                        form_id: '11123',
                    });
                    $('.form-message-container').append('<p class="form-message-good" style="text-align:center;margin-top:18px;color:#142058"><strong>An email with download links was sent to<br/>' + user_email + '</strong>.</p>');
                    $('.form-message-container').css('display', 'block');
                }

            },
            error: function(result) {
                $('.form-message-container').append('<p class="form-message-bad">An error occured while sending your email. Please try again later.</p>');
                $('.form-message-container').css('display', 'block');
            }
        });
    });


    // DEMPE WHITE PAPER REQUEST
    $('body').on('click', '#submit-dempe-white-paper-form', function() {

        var error = false;

        $('.form-message-container').empty();
        $('.form-message-container').css('display', 'none');

        $(".free-trial-form input.required").each(function(index) {
            if (!$(this).val()) {
                $(this).addClass('error');
                error = true;
            }
        });

        if (error) {
            $('.form-message-container').append('<p class="form-message-bad">You must fill all required fields.</p>');
            $('.form-message-container').css('display', 'block');
            return;
        }

        var user_name = sanitize($('.free-trial-form input[name="user_name"]').val());
        var user_email = sanitize($('.free-trial-form input[name="user_email"]').val());
        var user_company = sanitize($('.free-trial-form input[name="user_company"]').val());
        var user_comment = sanitize($('.free-trial-form textarea[name="user_comment"]').val());

        if (!user_email) {
            $('.free-trial-form input[name="user_email"]').addClass('error');
            error = true;
        } else if (!isValidEmailAddress(user_email)) {
            $('.free-trial-form input[name="user_email"]').addClass('error');
            $('.form-message-container').append('<p class="form-message-bad">The email is incorrect.</p>');
            $('.form-message-container').css('display', 'block');
            error = true;
        }

        if (error) {
            return;
        }

        $('#submit-dempe-white-paper-form').css('display', 'none');
        $('.free-trial-form .loader-container').css('display', 'block');

        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            data: {
                action: "ajax_dempe_white_paper_form",
                user_name: user_name,
                user_email: user_email,
                user_company: user_company,
                user_comment: user_comment,
            },
            success: function(result) {

                // $('#submit-dempe-white-paper-form').css('display','block');
                $('.free-trial-form .loader-container').css('display', 'none');

                $('#email-sent-form').css('display', 'block')
                $('.free-trial-form input[type="text"]').val('');
                $('.free-trial-form textarea').val('');

                $('.form-message-container').append('<p class="form-message-good white-paper-success">Your request has been submitted successfully. You will receive an email with a download link.</p>');
                $('.form-message-container').css('display', 'block');

                var today = new Date().toJSON();

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'formSubmitSuccess',
                    timeStamp: today,
                    form_name: 'DempeWhitePaper',
                    form_id: '11125',
                });

                bing_lead_conversion();
            },
            error: function(result) {
                $('.form-message-container').append('<p class="form-message-bad">An error occured while sending your email. Please try again later.</p>');
                $('.form-message-container').css('display', 'block');

            }
        });
    });

    // INIT LIVE CHAT
    $('body').on('click', '.live-chat-init', function(e) {
        e.preventDefault();

        $('.live-chat-init span').html('Please wait...');
        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            data: {
                action: "ajax_init_live_chat",
            },
            success: function(result) {
                // Append livechat scripts to head, to load resources
                $('head').append(result);

                // Check every second for live chat resources to load then open chat
                repeat_function(check_if_live_chat_ready, 2000, 20);
            }
        });

    });

    // repeat function for timeout every interval
    function repeat_function(fn, timeout, interval) {
        var startTime = (new Date()).getTime();
        interval = interval || 1000,
            canPoll = true;

        (function p() {
            canPoll = ((new Date).getTime() - startTime) <= timeout;
            if (!fn() && canPoll) { // ensures the function exucutes
                setTimeout(p, interval);
            }
        })();
    }

    var delta = 0;

    function check_if_live_chat_ready(params) {
        delta++;
        // Repeat until live chat is defined
        if (typeof LC_Invite != 'undefined') {
            LC_API.open_chat_window();
            return true;
        }
        // If something went wrong - terminate anyway
        if (delta > 100) {
            // console.log('terminate');
            return false;
        }
    }



    // FREE TRIAL FORM SUBMIT

    $('body').on('click', '#submit-free-trial-form', function() {

        var tax_summit = $(this).data('tax-summit');

        var error = false;

        $('.form-message-container').empty();
        $('.form-message-container').css('display', 'none');

        $(".free-trial-form input.required").each(function(index) {
            if (!$(this).val()) {
                $(this).addClass('error');
                error = true;
            }
        });

        if (error) {
            $('.form-message-container').append('<p class="form-message-bad">You must fill all required fields.</p>');
            $('.form-message-container').css('display', 'block');
            return;
        }

        var user_name = sanitize($('.free-trial-form input[name="user_name"]').val());
        var user_email = sanitize($('.free-trial-form input[name="user_email"]').val());
        var user_company = sanitize($('.free-trial-form input[name="user_company"]').val());
        var user_phone = sanitize($('.free-trial-form input[name="user_phone"]').val());
        var heard_via = sanitize($.trim($('.free-trial-form .CaptionCont.SelectBox').attr('title')));
        if (heard_via == 'Where did you hear about us?') {
            heard_via = '';
        }

        if (full_name_check(user_name) == false) {
            $('.free-trial-form input[name="user_name"]').addClass('error');

            $('.form-message-container').append('<p class="form-message-bad">Please enter your full name.</p>');
            $('.form-message-container').css('display', 'block');
            return;
        }

        var user_country = $('.flag-container .selected-flag').attr("title");

        user_country = user_country.substr(0, user_country.indexOf(':')); // Remove prefix

        if (user_country.indexOf("(") >= 0) {
            user_country = user_country.substr(0, user_country.indexOf('(')); // Remove native name
        }

        var prefix = $('.flag-container .selected-flag').attr("title");
        prefix = prefix.substr(prefix.indexOf(':') + 2);


        if (user_phone.length < 6) {
            $('.free-trial-form input[name="user_phone"]').addClass('error');
            $('.form-message-container').append('<p class="form-message-bad">Phone number is incorrect.</p>');
            $('.form-message-container').css('display', 'block');
            error = true;
        }

        var selected_products = '';
        $('.free-trial-form input[type=checkbox]:checked').each(function(index, el) {
            selected_products += $(this).val() + ', ';
        });

        if (selected_products == '') {
            $('.form-message-container').append('<p class="form-message-bad">You must select atleast one database.</p>');
            $('.form-message-container').css('display', 'block');
            return;
        }

        if (!user_email) {
            $('.free-trial-form input[name="user_email"]').addClass('error');
            error = true;
        } else if (!isValidEmailAddress(user_email)) {
            $('.free-trial-form input[name="user_email"]').addClass('error');
            $('.form-message-container').append('<p class="form-message-bad">The email is incorrect.</p>');
            $('.form-message-container').css('display', 'block');
            error = true;
        }

        if (user_company != undefined && user_company != '') {
            if (!isValidCompanyName(user_company)) {
                $('.free-trial-form input[name="user_company"]').addClass('error');
                error = true;
                $('.form-message-container').append('<p class="form-message-bad">The company name is incorrect.</p>');
                $('.form-message-container').css('display', 'block');
            }
        }

        if (error) {
            return;
        }

        $('#submit-free-trial-form').css('display', 'none');
        $('.free-trial-form .loader-container').css('display', 'block');

        var home_page = '';
        if ($(this).parents('.front-page-trial-form').length) {
            home_page = 'Homepage / mobile';
        }

        var gclid = get_google_ad_click_id();

        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            data: {
                action: "ajax_free_trial",
                user_name: user_name,
                user_email: user_email,
                user_company: user_company,
                user_phone: user_phone,
                selected_products: selected_products,
                tax_summit: tax_summit,
                user_country: user_country,
                heard_via: heard_via,
                home_page: home_page,
                gclid: gclid,
            },
            success: function(result) {
                console.log(result);
                // $('#submit-free-trial-form').css('display','block');
                $('.free-trial-form .loader-container').css('display', 'none');

                $('#email-sent-form').css('display', 'block')
                $('.free-trial-form input[type="text"]').val('');
                $('select.SlectBox')[0].sumo.unSelectAll();
                $('select.SlectBox')[0].sumo.selectItem(0);
                $('.CaptionCont.SelectBox span').addClass('placeholder');
                $('.CaptionCont.SelectBox span').text(' I heard of Royalty Range via');
                $('.CaptionCont.SelectBox').prop('title', ' I heard of Royalty Range via');


                $('.free-trial-form input[type="tel"]').val(prefix);
                $('.free-trial-form input:checkbox').prop('checked', false);
                $('.form-message-container').append('<p class="form-message-good">Your request has been submitted successfully.</p>');
                $('.form-message-container').css('display', 'block');

                // send event data to google analytics and adrwords
                // window.dataLayer = window.dataLayer || [];
                // window.dataLayer.push({
                //     event: event_name,
                //     ecommerce: {
                //         currencyCode: currency,
                //         purchase: [{
                //             products: [{
                //                 name: name, // Product name
                //                 id: id,  // product ID
                //                 // price: '500',  // product price
                //                 category: category,  // Product category
                //                 database: database,
                //                 plan: subscription_plan,
                //                 variant: variant // write-up option
                //             }]
                //         }]
                //     }
                // });
                if (typeof dataLayer !== 'undefined') {
                    // dataLayer.push({ 'event': 'formSubmitSuccess', 'formName': 'demoRequest' });
                }

                var today = new Date().toJSON();

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'formSubmitSuccess',
                    timeStamp: today,
                    form_name: 'demoTrialRequest',
                    form_id: '11126',
                });

                bing_lead_conversion();
                //Linkedin "Judita: Demo or trial" conversion
                window.lintrk('track', { conversion_id: 15335409 });

            },
            error: function(result) {
                console.log(result);
                $('.form-message-container').append('<p class="form-message-bad">An error occured while sending your email. Please try again later.</p>');
                $('.form-message-container').css('display', 'block');
            }
        });
    });

    // AI TRAINING FORM SUBMIT
    $('body').on('click', '#submit-ai-training-form', function() {
        var error = false;

        $('.form-message-container').empty();
        $('.form-message-container').css('display', 'none');

        $(".ai-training-request-form input.required").each(function(index) {
            if (!$(this).val()) {
                $(this).addClass('error');
                error = true;
            }
        });

        if (error) {
            $('.form-message-container').append('<p class="form-message-bad">You must fill all required fields.</p>');
            $('.form-message-container').css('display', 'block');
            return;
        }

        var user_name = sanitize($('.ai-training-request-form input[name="user_name"]').val());
        var user_email = sanitize($('.ai-training-request-form input[name="user_email"]').val());
        var user_company = sanitize($('.ai-training-request-form input[name="user_company"]').val());
        var user_phone = sanitize($('.ai-training-request-form input[name="user_phone"]').val());
        var user_comment = sanitize($('.ai-training-request-form textarea[name="user_comment"]').val());

        if (full_name_check(user_name) == false) {
            $('.ai-training-request-form input[name="user_name"]').addClass('error');

            $('.form-message-container').append('<p class="form-message-bad">Please enter your full name.</p>');
            $('.form-message-container').css('display', 'block');
            return;
        }

        var user_country = $('.flag-container .selected-flag').attr("title");

        user_country = user_country.substr(0, user_country.indexOf(':')); // Remove prefix

        if (user_country.indexOf("(") >= 0) {
            user_country = user_country.substr(0, user_country.indexOf('(')); // Remove native name
        }

        var selected_products = '';
        $('.ai-training-request-form input[type=checkbox]:checked').each(function(index, el) {
            selected_products += $(this).val() + ', ';
        });

        if (selected_products == '') {
            $('.form-message-container').append('<p class="form-message-bad">You must select atleast one database.</p>');
            $('.form-message-container').css('display', 'block');
            return;
        }

        var prefix = $('.flag-container .selected-flag').attr("title");
        prefix = prefix.substr(prefix.indexOf(':') + 2);

        if (user_phone.length < 6) {
            $('.ai-training-request-form input[name="user_phone"]').addClass('error');
            $('.ai-training-request-form').append('<p class="form-message-bad">Phone number is incorrect.</p>');
            $('.ai-training-request-form').css('display', 'block');
            error = true;
        }

        if (!user_email) {
            $('.ai-training-request-form input[name="user_email"]').addClass('error');
            error = true;
        } else if (!isValidEmailAddress(user_email)) {
            $('.ai-training-request-form input[name="user_email"]').addClass('error');
            $('.form-message-container').append('<p class="form-message-bad">The email is incorrect.</p>');
            $('.form-message-container').css('display', 'block');
            error = true;
        }

        if (user_company != undefined && user_company != '') {
            if (!isValidCompanyName(user_company)) {
                $('.ai-training-request-form input[name="user_company"]').addClass('error');
                error = true;
                $('.form-message-container').append('<p class="form-message-bad">The company name is incorrect.</p>');
                $('.form-message-container').css('display', 'block');
            }
        }

        if (error) {
            return;
        }

        $('#submit-ai-training-form').css('display', 'none');
        $('.ai-training-request-form .loader-container').css('display', 'block');

        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            data: {
                action: "ajax_ai_training_submit",
                user_id: 0,
                user_name: user_name,
                user_email: user_email,
                user_company: user_company,
                user_phone: user_phone,
                user_country: user_country,
                selected_products: selected_products,
                user_comment: user_comment,
            },
            success: function(result) {
                $('.ai-training-request-form .loader-container').css('display', 'none');

                $('#email-sent-form').css('display', 'block')
                $('.ai-training-request-form input[type="text"]').val('');
                $('.ai-training-request-form input[type="tel"]').val(prefix);
                $('.ai-training-request-form input:checkbox').prop('checked', false);
                $('.form-message-container').append('<p class="form-message-good">Your request has been submitted successfully.</p>');
                $('.form-message-container').css('display', 'block');

                var today = new Date().toJSON();

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'formSubmitSuccess',
                    timeStamp: today,
                    form_name: 'aiTrainingRequest',
                    form_id: '11126',
                });
            },
            error: function(result) {
                $('.form-message-container').append('<p class="form-message-bad">An error occured while sending your email. Please try again later.</p>');
                $('.form-message-container').css('display', 'block');
            }
        });
    });

    var trial_form_inputs_added = "false";
    $(".front-page-trial-form .database-options input").change(function() {

        // if (loaded == "loaded"){
        // if ( $("#user-phone").length > 0  ){
        //     console.log('this');
        //     try { $("#user-phone").intlTelInput({});} catch(err) { }
        // }
        // if ( $('.found-via').length > 0){
        //     try { $('.found-via').SumoSelect();} catch(err) { }
        // }
        // }

        if (trial_form_inputs_added == "false") {
            $(".trial-general-information").css('display', 'block');
            // var trial_form_general_information_inputs = '<div class="input-container"><label for="user_name">Your name: <span class="required-label">(required)</span></label><input type="text" name="user_name" id="user_name" class="input wide required" value="" size="20" placeholder="Full name" autofocus/></div><div class="input-container"><label for="user_email">Your email address: <span class="required-label">(required)</span></label><input type="text" name="user_email" id="user_email" class="input wide required" value="" size="20" placeholder="name@email.com"/></div><div class="input-container"><label for="user_company">Company name: <span class="required-label">(required)</span></label><input type="text" name="user_company" id="user_company" class="input wide required" value="" size="20" placeholder="Company name"/></div><div class="input-container"><label for="user-phone">Your phone number: <span class="required-label">(required)</span></label><input id="user-phone" class="input wide required" type="tel" value="+1" name="user_phone"></div><div class="input-container"><label for="found_via">Where did you hear about us?</label><select name="found_via" class="SlectBox found-via" placeholder="Where did you hear about us?"><option selected disabled value="Where did you hear about us?">Where did you hear about us?</option><option value="Client referral">Client referral</option><option value="Event">Event</option><option value="Conference">Conference</option><option value="Web search">Web search</option><option value="Mail">Mail</option><option value="LinkedIn">LinkedIn</option><option value="Twitter">Twitter</option><option value="Facebook">Facebook</option><option value="Bing">Bing</option><option value="Other">Other</option></select></div>';
            //
            // $(".trial-general-information").append(trial_form_general_information_inputs);
            //
            // $("#submit-free-trial-form").css('display','block');
            //
            // var loaded = homepage_one_search_form_activate_load_assets();
            //
            // trial_form_inputs_added = "true";
        }
    });

    var ai_form_inputs_added = "false";
    $(".front-page-trial-form .database-options input").change(function() {

        // if (loaded == "loaded"){
        // if ( $("#user-phone").length > 0  ){
        //     console.log('this');
        //     try { $("#user-phone").intlTelInput({});} catch(err) { }
        // }
        // if ( $('.found-via').length > 0){
        //     try { $('.found-via').SumoSelect();} catch(err) { }
        // }
        // }

        if (ai_form_inputs_added == "false") {
            $(".ai-training-general-information").css('display', 'block');
            // var trial_form_general_information_inputs = '<div class="input-container"><label for="user_name">Your name: <span class="required-label">(required)</span></label><input type="text" name="user_name" id="user_name" class="input wide required" value="" size="20" placeholder="Full name" autofocus/></div><div class="input-container"><label for="user_email">Your email address: <span class="required-label">(required)</span></label><input type="text" name="user_email" id="user_email" class="input wide required" value="" size="20" placeholder="name@email.com"/></div><div class="input-container"><label for="user_company">Company name: <span class="required-label">(required)</span></label><input type="text" name="user_company" id="user_company" class="input wide required" value="" size="20" placeholder="Company name"/></div><div class="input-container"><label for="user-phone">Your phone number: <span class="required-label">(required)</span></label><input id="user-phone" class="input wide required" type="tel" value="+1" name="user_phone"></div><div class="input-container"><label for="found_via">Where did you hear about us?</label><select name="found_via" class="SlectBox found-via" placeholder="Where did you hear about us?"><option selected disabled value="Where did you hear about us?">Where did you hear about us?</option><option value="Client referral">Client referral</option><option value="Event">Event</option><option value="Conference">Conference</option><option value="Web search">Web search</option><option value="Mail">Mail</option><option value="LinkedIn">LinkedIn</option><option value="Twitter">Twitter</option><option value="Facebook">Facebook</option><option value="Bing">Bing</option><option value="Other">Other</option></select></div>';
            //
            // $(".trial-general-information").append(trial_form_general_information_inputs);
            //
            // $("#submit-free-trial-form").css('display','block');
            //
            // var loaded = homepage_one_search_form_activate_load_assets();
            //
            // trial_form_inputs_added = "true";
        }
    });

    // HOME PAGE ONE SEARCH FORM FUNCTIONS
    var home_page_assets_loaded = false;

    function homepage_one_search_form_activate_load_assets() {
        if (home_page_assets_loaded) {
            return 'loaded';
        } else {
            home_page_assets_loaded = true;
        }

        $.ajax({
            type: 'POST',
            url: ajax_object.ajaxurl,
            data: {
                action: "get_front_page_one_search_forms",
            },
            success: function(response) {

                $("#front-page-one-search-nic-sic-forms").append(response);
                window.sb = $('.select-box').SumoSelect({ csvDispCount: 3, search: true, searchText: '', floatWidth: 99999, forceCustomRendering: true, okCancelInMulti: false });

                $($("span.load-later")).each(function(index) {
                    var type = $(this).data('type');
                    var src = $(this).data('src');
                    var handle = $(this).attr('id');
                    var html = "";

                    if (type == "style") {
                        html = '<link rel="stylesheet" id="' + handle + '" href="' + src + '" media="all">';
                    }

                    if (type == "script") {
                        html = '<script type="text/javascript" src="' + src + '"></script>';
                    }

                    $("footer").append(html);

                });

            }
        });
    }

    $(".form-content-wrapper.first-step .added-criteria-input").focus(function() {
        // homepage_one_search_form_activate_load_assets();
    });

    $("#start-front-page-request-form").click(function() {
        // If sidebar exists
        if ($('.landing-side-bar').length) {
            close_one_search_right_form();
            close_benchmarking_right_form();
            sticky_landing_side_bar();
        }

        var button_text = $(this).text();
        var step = $(this).data('step');
        var error = false;
        var keywords = $('#front-page-one-search-request-form .first-step .added-criteria-input[data-criteria="Key Words"]').val();

        homepage_one_search_form_activate_load_assets();
        // jQuery('.popup-form').on('click', '.close-popup', closePopupWindow);
        // jQuery('.popup-form').on('click', '.popup-done', closePopupWindow);
        $('#front-page-one-search-request-form .one-search-form-container').css('background-color', 'rgba(255,255,255,1)');
        $(".front-page-header .width-wrap").css("z-index", "9999");
        $('.first-step').css('display', 'none');
        $('.second-step').css('display', 'block');
        $('#front-page-one-search-request-form.overview-form').addClass('second-step-active');
        $('.front-page-background-overlay').toggleClass('show');
        $("#submit-front-page-request-form").html('Next');
        $('#submit-front-page-request-form').data('step', '2');
        $('#start-front-page-request-form').css('display', 'none');
        $('#submit-front-page-request-form').css('display', 'inline-block');
        $('.form-message-container').empty();
        $('#front-page-one-search-request-form .close-popup').css('display', 'block');
        // $(".one-search-form-container .custom-checkbox-container").focus();

        // $(".second-step").focus();

        setTimeout(function() { $(".close-form").focus(); }, 20);

        // console.log(1);

        $('#front-page-one-search-request-form .second-step .added-criteria-input[data-criteria="Key Words"]').val(keywords);
        autogrow($('#front-page-one-search-request-form .second-step .added-criteria-input[data-criteria="Key Words"]'));
    });

    $('#front-page-one-search-request-form .close-popup').on('click', function() {
        $('.first-step').css('display', 'block');
        $('.second-step').css('display', 'none');
        $("#submit-front-page-request-form").css('display', 'none');
        $('#start-front-page-request-form').css('display', 'block');
    });

    $("#submit-front-page-request-form").click(function() {
        // If sidebar exists
        if ($('.landing-side-bar').length) {
            close_one_search_right_form();
            close_benchmarking_right_form();
            sticky_landing_side_bar();
        }

        var button_text = $(this).text();
        var step = $(this).data('step');
        var error = false;
        var keywords = $('#front-page-one-search-request-form .first-step .added-criteria-input[data-criteria="Key Words"]').val();

        keywords = $('#front-page-one-search-request-form .second-step .added-criteria-input[data-criteria="Key Words"]').val();

        industry = $('#front-page-one-search-request-form .second-step .added-criteria-input[data-criteria="Industry"]').val();

        $('.form-message-bad').text('');
        $('.form-message-container').css('display', 'none');

        if ($('.user-message-wrapper .allow-send').val()) {
            error = true;
        }

        var user_email = sanitize($('.user-message-wrapper input[name="user_email"]').val());
        var user_name = sanitize($('.user-message-wrapper input[name="user_full_name"]').val());
        var user_phone = sanitize($('.user-message-wrapper input[name="user_phone"]').val());
        var user_company = sanitize($('.user-message-wrapper input[name="user_company_name"]').val());
        var country_with_number = sanitize($('.intl-tel-input .selected-flag').attr("title"));
        // console.log(country_with_number);
        if (country_with_number == undefined) {
            var user_country = '';
        } else {
            var country_number_array = country_with_number.split(':');
            var user_country = country_number_array[0];
        }
        console.log(user_country);

        if (user_phone == undefined || user_phone.length < 6) {
            user_phone = '';
        }

        if (user_company == undefined) {
            user_company = '';
        }

        if (full_name_check(user_name) == false) {
            $('.user-message-wrapper input[name="user_full_name"]').addClass('error');

            message = "Please enter your full name.";
            $('.form-message-bad').text(message);
            $('.form-message-container').css('display', 'block');
            return;
        }

        // IF EMAIL IS INCORRECT
        if (!isValidEmailAddress(user_email) && user_email != undefined) {
            $('.user-message-wrapper input[name="user_email"]').addClass('error');
            message = "The email you have entered is invalid. Pleach check again.";
            $('.form-message-bad').text(message);
            $('.form-message-container').css('display', 'block');
            error = true;
        }

        if (user_company != undefined && user_company != '') {
            if (!isValidCompanyName(user_company)) {
                $('.user-message-wrapper input[name="user_company_name"]').addClass('error');
                error = true;
                message = "The company name you have entered is invalid. Pleach check again.";
                $('.form-message-bad').text(message);
                $('.form-message-container').css('display', 'block');
            }
        }

        $('#front-page-one-search-request-form #phone.required').each(function(index) {
            phone_validation = $(this).val();
            if (phone_validation.length < 6) {
                $(this).addClass('error');
                message = "Phone number is incorrect.";
                $('.form-message-bad').text(message);
                $('.form-message-container').css('display', 'block');
                error = true;
            }
        });

        $('#front-page-one-search-request-form .required').each(function(index) {
            if (!$(this).val()) {
                $(this).addClass('error');
                message = "You must fill all required fields.";
                $('.form-message-bad').text(message);
                $('.form-message-container').css('display', 'block');
                error = true;
            }
        });

        $('#front-page-one-search-request-form .custom-select.required-country').each(function(index) {
            if ($(this).children('.select-selected').text() === 'Territory') {
                $(this).addClass('error');
                message = "You must fill all required fields.";
                $('.form-message-bad').text(message);
                $('.form-message-container').css('display', 'block');
                error = true;
            } else {
                $(this).removeClass('error');
            }
        });


        if (error) {
            return;
        }

        var request_type = $("#front-page-one-search-request-form").data('service-type');
        var database_type = $("#front-page-one-search-request-form").data('database-type');
        var subscription_plan = '';
        var criteria = {};
        var write_up = false;

        if ($('#write-up').is(':checked')) {
            criteria['Write-up'] = 'I would like to order RoyaltyRange search strategy write-up';
            write_up = 'true';
        }

        if (request_type == "one-search" || request_type == "benchmarking-study" || request_type == "lead-search" || request_type == "company-financials-search") {
            $('.added-criteria-input').each(function(index, el) {
                var key = $(this).data('criteria');
                var criterion = $(this).val();
                criteria[key] = criterion;
            });
            $('#front-page-one-search-request-form .custom-select.required-country').each(function(index) {
                if ($(this).children('.select-selected').text() === 'Territory') {

                } else {
                    $(this).removeClass('error');
                    criteria['Territory'] = $(this).children('.select-selected').text();
                    criteria['ProfitLevel'] = $(this).children('.select-selected').text();
                }
                // console.log($(this).children('.select-selected').text());
            });
        }

        var newsletter_consent = $("#newsletter_consent").is(":checked");
        console.log(newsletter_consent);
        var user_message = $("#user-message").val();
        //var offer_code = $("#offer_code").val();
        var user_id = $('#front-page-one-search-request-form').data('user-id');

        if (!user_email) {
            user_email = $('#front-page-one-search-request-form').data('user-email');
        }

        $(this).css('display', 'none');
        $('.request-form-loader-container').css('display', 'block');

        var currency = $('#front-page-one-search-request-form').data('user-currency');

        var mobile = check_if_mobile();
        if (mobile == "true") {
            mobile = "mobile";
        } else {
            mobile = "";
        }

        var front_page = window.location.href;

        if ($(this).data('landing-page') == "landing-page") {
            $('article')
                // var link = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
            var link = $(location).attr("href");
            var front_page = 'Landing page : ' + link;
        }
        var gclid = get_google_ad_click_id();

        $.ajax({
            type: 'POST',
            url: ajax_object.ajaxurl,
            dataType: 'text',
            data: {
                action: "user_send_request",
                user_message: user_message,
                //offer_code: offer_code,
                user_id: user_id,
                user_email: user_email,
                user_name: user_name,
                user_company: user_company,
                user_country: user_country,
                request_type: request_type,
                subscription_plan: subscription_plan,
                // amount: amount,
                front_page: front_page,
                mobile: mobile,
                currency: currency,
                database_type: database_type,
                write_up: write_up,
                user_phone: user_phone,
                newsletter_consent: newsletter_consent,
                gclid: gclid,
                criteria: JSON.stringify(criteria)
            },
            success: function(response) {
                adwords_one_search_benchmarking_subscription(request_type, database_type, subscription_plan, currency, write_up);
                bing_lead_conversion();
                window.lintrk('track', { conversion_id: 6059137 });
                window.location.href = "/thank-you-reg/";
            }
        });


    });

    // ADWORDS FUNCTIONS
    function adwords_one_search_benchmarking_subscription(request_type, database_type, subscription_plan, currency, write_up) {
    /*
        var event_name, name, id, category, variant, database;

        if (request_type == "one-search") {
            event_name = "OneSearchLead";
            category = "One Search";
        }
        if (request_type == "benchmarking-study") {
            event_name = "BenchmarkingLead";
            category = "Benchmarking Study";
        }
        if (request_type == "database-subscription") {
            event_name = "SubscriptionLead";
            category = "Subscription";
        }

        if (request_type == "lead-search") {
            event_name = "RequestLeadSearch";
        }

        if (request_type == "company-financials-search") {
            event_name = "CompanyFinancialsSearch";
        }

        if (database_type == "royalty-rates") database = "Royalty Rates";
        if (database_type == "loan-interest-rates") database = "Loan Interest Rates";
        if (database_type == "service-fees") database = "Service Fees";
        if (database_type == "company-financials") database = "Company Financials";

        name = category + " " + database;

        if (name == "One Search Royalty Rates") id = 11111;
        if (name == "One Search Loan Interest Rates") id = 11112;
        if (name == "One Search Service Fees") id = 11113;
        if (name == "Benchmarking Study Royalty Rates") id = 11114;
        if (name == "Benchmarking Study Loan Interest Rates") id = 11115;
        if (name == "Benchmarking Study Service Fees") id = 11116;
        if (name == "Subscription Royalty Rates") id = 11117;
        if (name == "Subscription Loan Interest Rates") id = 11118;
        if (name == "Subscription Service Fees") id = 11119;
        if (name == "One Search Company Financials") id = 11120;
        if (name == "Subscription Company Financials") id = 11121;
        if (name == "Request Lead Search ") id = 11122;

        variant = "";
        if (write_up) {
            variant = "Write-up";
        }

        // console.log("currency: " + currency);
        // console.log("name: " + name);
        // console.log("id: " + id);
        // console.log("category: " + category);
        // console.log("database: " + database);
        // console.log("subscription_plan: " + subscription_plan);
        // console.log("variant: " + variant);

        var today = new Date().toJSON();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'formSubmitSuccess',
            timeStamp: today,
            form_name: event_name,
            form_id: id,
            ecommerce: {
                currencyCode: currency,
                purchase: [{
                    products: [{
                        name: name, // Product name
                        id: id, // product ID
                        // price: '500',  // product price
                        category: category, // Product category
                        database: database,
                        plan: subscription_plan,
                        variant: variant // write-up option
                    }]
                }]
            }
        });
    */
    }


    function bing_lead_conversion() {
        // (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"5662786"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");
        // (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"5662786"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");
        //
        // window.uetq = window.uetq || [];
        //
        // window.uetq.push('event', 'Lead', {'event_category': 'Lead', 'event_label': 'Lead', 'event_value': 400});

    }



    // FRONT PAGE TRIAL FORM FUNCTIONS



    // MAIN ACTIONS
    $('body').on('keydown', '.autogrow', function() {
        // var el = $(this);
        // setTimeout(function(){
        //   el.css('height','auto');
        //   el.css('padding','7px 12px');
        //   el.css('height', (el.prop("scrollHeight") + 2 ) + 'px');
        // },0);
        autogrow($(this));
    });

    function autogrow(el) {
        setTimeout(function() {
            el.css('height', 'auto');
            el.css('padding', '7px 12px');
            el.css('height', (el.prop("scrollHeight") + 2) + 'px');
        }, 0);
    }

    $(document).ready(function() {
        var autogrow = $('textarea.autogrow');

        autogrow.each(function(index) {
            var el = $(this);
            el.css('height', 'auto');
            el.css('padding', '7px 12px');
            el.css('height', (el.prop("scrollHeight") + 2) + 'px');
        });

    });

    function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    }

    function sanitize(input) {
        if (input != '' && input) {
            var output = input.replace(/<script[^>]*?>.*?<\/script>/gi, '').
            replace(/<[\/\!]*?[^<>]*?>/gi, '').
            replace(/<style[^>]*?>.*?<\/style>/gi, '').
            replace(/<![\s\S]*?--[ \t\n\r]*>/gi, '');

        } else {
            var output = input;
        }
        return output;
    }

    function isValidEmailAddress(emailAddress) {
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        return pattern.test(emailAddress);
    };

    function isValidCompanyName(companyName) {
        if (companyName.indexOf('@') > -1) {
            return false;
        } else {
            return true;
        }
    }

    function isValidFullName(userName) {
        var name_array = explode(' ', userName);
        if (count(name_array) > 0) {
            return true;
        } else {
            return false;
        }
    }

    function check_if_email_exists(email) {
        var answer = '';

        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            data: {
                action: "ajax_check_if_email_exists",
                email: email,
            },
            success: function(result) {
                answer = result;
                return answer;
            },
            error: function(result) {
                answer = result;
            }
        });
    }

    // WINDOW WIDTH
    function viewportWidth() {
        var e = window,
            a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return e[a + 'Width'];
    }

    // WINDOW HEIGHT
    function viewportHeight() {
        var e = window,
            a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return e[a + 'Height'];
    }


    function check_if_mobile() {
        var isMobile = "false"; //initiate as false
        // device detection
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
            isMobile = "true";
        }
        return isMobile;
    }

    function check_if_urls_working($urls) {

        $.each(urls, function(index, url) {
            $.ajax({
                cache: false,
                url: url,
                success: function() {
                    console.log(url + ' - working');
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    if (xhr.status == 404) {
                        console.log(url + ' - not working');
                    }
                }
            });
        });
    }


    function closeFrontPageRequestForm() {
        $('#submit-front-page-request-form').data('step', '1');
        $('.first-step').css('display', 'block');
        $('.second-step').css('display', 'none');
        $('.third-step').css('display', 'none');
        $('#front-page-one-search-request-form .close-popup').css('display', 'none');
        $('#front-page-one-search-request-form .one-search-form-container').css('background-color', 'rgba(255,255,255,0,2)');
        $('#front-page-one-search-request-form.overview-form').removeClass('second-step-active');
        $('.front-page-background-overlay').removeClass('show');
        $(".front-page-header .width-wrap").css("z-index", "2");

        var new_keywords = $('#front-page-one-search-request-form .second-step .added-criteria-input[data-criteria="Key Words"]').val();
        $('#front-page-one-search-request-form .first-step .added-criteria-input[data-criteria="Key Words"]').val(new_keywords);
    }

    // LANDING PAGE READY-MADE BENCHMARKING FUNCTIONS

    function close_benchmarking_right_form() {
        $(".ready-made-benchmarks.overview-form .close-right-form").remove();
        $("#benchmarking-ready-made-form").css("display", 'none');
        $(".ready-made-benchmarks.overview-form .hiding-container").css("display", "block");
        $("#show-benchmarking-ready-made").html("Order here");
        sticky_landing_side_bar(1);
    }

    function close_benchmarking_left_form() {
        $('.landing-background-overlay').removeClass('show');
        $(".benchmarks-selection-left").css('display', 'none');
        $(".benchmarks-selection-left").css('opacity', '1');
    }

    // Close left side
    $(".overview-form").on('click', '.benchmarks-selection-left .close-left-form', function() {
        close_benchmarking_left_form();
    });

    // Close right side
    $(".ready-made-benchmarks.overview-form").on('click', '.close-right-form', function() {
        close_benchmarking_right_form();
    });

    // Show ready-made benchmarks selection list
    $('.site-content-container').on('click', '.open-ready-made-benchmark-list a', function(e) {
        e.preventDefault();
        // $('.select-box-original').SumoSelectOriginal({ csvDispCount: 5, search: true, searchText:'', forceCustomRendering: true});
        $('.landing-background-overlay').toggleClass('show');
        $('.benchmarks-selection-left').css("display", "block");
        $('.benchmarks-selection-left').css("opacity", "1");
        $(".benchmarks-selection-left").append('<div class="close-form close-left-form"><svg xmlns="http://www.w3.org/2000/svg" viewBox="26 -26 100 125"><path class="st0" d="M82.2 23.5l31.9 31.9c1.9 1.9 1.9 4.9 0 6.7-1.9 1.9-4.9 1.9-6.7 0L75.5 30.2 43.6 62.1c-1.9 1.9-4.9 1.9-6.7 0-1.9-1.9-1.9-4.9 0-6.7l31.9-31.9L36.9-8.4c-1.9-1.9-1.9-4.9 0-6.7 1.9-1.9 4.9-1.9 6.7 0l31.9 31.9 31.9-31.9c1.9-1.9 4.9-1.9 6.7 0 1.9 1.9 1.9 4.9 0 6.7L82.2 23.5z"></path></svg></div>');
    });

    // Show ready-made benchmarks form
    var benchmarking_ready_made_loaded = 0;

    $("#show-benchmarking-ready-made").click(function() {

        close_one_search_right_form();
        closeFrontPageRequestForm();

        $(this).html('Loading...');

        if (benchmarking_ready_made_loaded == 1) {
            $("#benchmarking-ready-made-form").css("display", 'block');
            $(".ready-made-benchmarks .hiding-container").hide();
            $(".ready-made-benchmarks.overview-form").append('<div class="close-form close-right-form"><svg xmlns="http://www.w3.org/2000/svg" viewBox="26 -26 100 125"><path class="st0" d="M82.2 23.5l31.9 31.9c1.9 1.9 1.9 4.9 0 6.7-1.9 1.9-4.9 1.9-6.7 0L75.5 30.2 43.6 62.1c-1.9 1.9-4.9 1.9-6.7 0-1.9-1.9-1.9-4.9 0-6.7l31.9-31.9L36.9-8.4c-1.9-1.9-1.9-4.9 0-6.7 1.9-1.9 4.9-1.9 6.7 0l31.9 31.9 31.9-31.9c1.9-1.9 4.9-1.9 6.7 0 1.9 1.9 1.9 4.9 0 6.7L82.2 23.5z"></path></svg></div>');
            sticky_landing_side_bar();
        } else {

            benchmarking_ready_made_loaded = 1;

            $.ajax({
                url: ajax_object.ajaxurl,
                type: "post",
                data: {
                    action: "ajax_get_ready_made_benchmarking_form",
                    preselected_benchmarks: $(this).data('preselected-benchmarks'),
                },
                success: function(result) {
                    $(".ready-made-benchmarks .hiding-container").hide();
                    $(".ready-made-benchmarks.overview-form").append('<div class="close-form close-right-form"><svg xmlns="http://www.w3.org/2000/svg" viewBox="26 -26 100 125"><path class="st0" d="M82.2 23.5l31.9 31.9c1.9 1.9 1.9 4.9 0 6.7-1.9 1.9-4.9 1.9-6.7 0L75.5 30.2 43.6 62.1c-1.9 1.9-4.9 1.9-6.7 0-1.9-1.9-1.9-4.9 0-6.7l31.9-31.9L36.9-8.4c-1.9-1.9-1.9-4.9 0-6.7 1.9-1.9 4.9-1.9 6.7 0l31.9 31.9 31.9-31.9c1.9-1.9 4.9-1.9 6.7 0 1.9 1.9 1.9 4.9 0 6.7L82.2 23.5z"></path></svg></div>');
                    $(".benchmark-landing-page-form").append(result);
                    $("#benchmarking_country").countrySelect();
                    sticky_landing_side_bar();
                    $('.select-box-original').SumoSelectOriginal({ csvDispCount: 5, search: true, searchText: '', forceCustomRendering: true });
                },
                error: function(result) {}
            });
        }
    });

    function clean_country_name(countryName) {
        if (countryName === undefined || countryName.indexOf('(') < 1) {
            return countryName;
        }

        return countryName.substring(0, countryName.indexOf('(') - 1).trim();
    }



    // LANDING PAGE READY-MADE ONE SEARCH FUNCTIONS

    // Close left side

    function close_one_search_right_form() {
        $(".ready-made-one-searches.overview-form .close-right-form").remove();
        $("#one-search-ready-made-form").css("display", 'none');
        $(".ready-made-one-searches.overview-form .hiding-container").css("display", "block");
        $("#show-one-search-ready-made").html("Order here");
        sticky_landing_side_bar(1);

    }

    function close_one_search_left_form() {
        $('.landing-background-overlay').removeClass('show');
        $(".one-search-selection-left").css('display', 'none');
        $(".one-search-selection-left").css('opacity', '1');
    }

    $(".overview-form").on('click', '.one-search-selection-left .close-left-form', function() {
        close_one_search_left_form();
    });

    // Close right side
    $(".ready-made-one-searches.overview-form").on('click', '.close-right-form', function() {
        close_one_search_right_form();
    });

    // Show ready-made benchmarks selection list
    $('.site-content-container').on('click', '.open-ready-made-one-search-list a', function(e) {

        $(".ready-made-benchmarks.overview-form .close-right-form").remove();
        $("#benchmarking-ready-made-form").css("display", 'none');
        $(".ready-made-benchmarks.overview-form .hiding-container").css("display", "block");
        $("#show-benchmarking-ready-made").html("Order here");

        e.preventDefault();
        // $('.select-box-original').SumoSelectOriginal({ csvDispCount: 5, search: true, searchText:'', forceCustomRendering: true});
        $('.one-search-selection-left').css("display", "block");
        $('.one-search-selection-left').css("opacity", "1");
        $(".one-search-selection-left").append('<div class="close-form close-left-form"><svg xmlns="http://www.w3.org/2000/svg" viewBox="26 -26 100 125"><path class="st0" d="M82.2 23.5l31.9 31.9c1.9 1.9 1.9 4.9 0 6.7-1.9 1.9-4.9 1.9-6.7 0L75.5 30.2 43.6 62.1c-1.9 1.9-4.9 1.9-6.7 0-1.9-1.9-1.9-4.9 0-6.7l31.9-31.9L36.9-8.4c-1.9-1.9-1.9-4.9 0-6.7 1.9-1.9 4.9-1.9 6.7 0l31.9 31.9 31.9-31.9c1.9-1.9 4.9-1.9 6.7 0 1.9 1.9 1.9 4.9 0 6.7L82.2 23.5z"></path></svg></div>');
        $(".landing-background-overlay").toggleClass('show');
    });

    $('.site-content-container').on('click', '.landing-background-overlay', function(e) {
        $(".landing-background-overlay").removeClass("show");
        close_one_search_left_form();
        close_benchmarking_left_form();
    });

    // Show ready-made benchmarks form
    var one_search_ready_made_loaded = 0;

    $("#show-one-search-ready-made").click(function() {

        close_benchmarking_right_form();
        closeFrontPageRequestForm();

        $(this).html('Loading...');

        if (one_search_ready_made_loaded == 1) {
            $("#one-search-ready-made-form").css("display", 'block');
            $(".ready-made-one-searches .hiding-container").hide();
            $(".ready-made-one-searches.overview-form").append('<div tabindex="0" class="close-form close-right-form"><svg xmlns="http://www.w3.org/2000/svg" viewBox="26 -26 100 125"><path class="st0" d="M82.2 23.5l31.9 31.9c1.9 1.9 1.9 4.9 0 6.7-1.9 1.9-4.9 1.9-6.7 0L75.5 30.2 43.6 62.1c-1.9 1.9-4.9 1.9-6.7 0-1.9-1.9-1.9-4.9 0-6.7l31.9-31.9L36.9-8.4c-1.9-1.9-1.9-4.9 0-6.7 1.9-1.9 4.9-1.9 6.7 0l31.9 31.9 31.9-31.9c1.9-1.9 4.9-1.9 6.7 0 1.9 1.9 1.9 4.9 0 6.7L82.2 23.5z"></path></svg></div>');
            sticky_landing_side_bar();
            // setTimeout(function() {
            //     $(".ready-made-one-searches.overview-form .close-form").focus();
            // }, 20);

        } else {

            one_search_ready_made_loaded = 1;

            $.ajax({
                url: ajax_object.ajaxurl,
                type: "post",
                data: {
                    action: "ajax_get_ready_made_one_search_form",
                    preselected_one_search: $(this).data('preselected-one-search'),
                },
                success: function(result) {
                    $(".ready-made-one-searches .hiding-container").hide();
                    $(".ready-made-one-searches.overview-form").append('<div tabindex="0" class="close-form close-right-form"><svg xmlns="http://www.w3.org/2000/svg" viewBox="26 -26 100 125"><path class="st0" d="M82.2 23.5l31.9 31.9c1.9 1.9 1.9 4.9 0 6.7-1.9 1.9-4.9 1.9-6.7 0L75.5 30.2 43.6 62.1c-1.9 1.9-4.9 1.9-6.7 0-1.9-1.9-1.9-4.9 0-6.7l31.9-31.9L36.9-8.4c-1.9-1.9-1.9-4.9 0-6.7 1.9-1.9 4.9-1.9 6.7 0l31.9 31.9 31.9-31.9c1.9-1.9 4.9-1.9 6.7 0 1.9 1.9 1.9 4.9 0 6.7L82.2 23.5z"></path></svg></div>');
                    $(".one-search-landing-page-form").append(result);
                    $("#one-search-country").countrySelect();
                    sticky_landing_side_bar();
                    $('.select-box-original').SumoSelectOriginal({ csvDispCount: 5, search: true, searchText: '', forceCustomRendering: true });
                    // setTimeout(function() {
                    //     $(".ready-made-one-searches.overview-form .close-form").focus();
                    // }, 20);
                },
                error: function(result) {}
            });
        }
    });


    // PAYMENT PAGE EXPAND DESCRIPTION
    $(".files-list-holder").on('click', '.payment-show-benchmarking-description', function(e) {

        e.preventDefault();
        $(this).toggleClass('open');
        $(this).parents('.purchase-file-row').find('.payment-benchmarking-description').toggleClass('open');
    });

    $(window).scroll(function() {

        if ($('.landing-side-bar').length) {
            sticky_landing_side_bar();
        }

    });

    $(window).resize(function() {
        if ($('.landing-side-bar').length) {
            if (side_bar_state == "stick_top" || side_bar_state == "stick_bottom") {
                var viewport_width = viewportWidth();
                var wrapper_width = $(".width-wrap.landing").width();
                var side_bar_right = ($(document).width() - wrapper_width) / 2;

                var side_bar = $(".landing-side-bar");
                side_bar.css('right', side_bar_right + 'px');
            }

            // console.log(viewportWidth());
            if (viewportWidth() <= 1200) {
                reset_side_bar();
            }
        }
    });

    function reset_side_bar() {
        var side_bar_state = 'initial';
        var side_bar = $(".landing-side-bar");

        side_bar.css('position', 'relative');
        side_bar.css('top', 'auto');
        side_bar.css('right', 'auto');

    }

    // Landing page sticky site-bar
    var initial_position = 0;
    var side_bar_state = 'initial';
    var prev_scroll_pos = 0;

    function sticky_landing_side_bar(stick_back) {

        if ($(document).width() <= 1200) {
            return;
        }

        var scrolled_from_top = $(document).scrollTop();

        // fixed heights
        var menu_height = 121;

        if ($(document).width() <= 1185) {
            menu_height = 114;
        }

        var admin_menu_height = 32;

        // console.log(admin_menu_height);

        var top_border = $(".width-wrap.landing").offset();
        var top_border = top_border.top;
        var bottom_border = top_border + $(".width-wrap.landing").height();
        top_border = top_border + admin_menu_height;

        var menu_bottom_pos = menu_height + scrolled_from_top;

        var side_bar = $(".landing-side-bar");
        var side_bar_height = side_bar.height();
        var side_bar_offset = side_bar.offset();
        var side_bar_top_pos = side_bar_offset.top;
        var side_bar_bottom_pos = side_bar_height + side_bar_top_pos;

        var viewport_height = viewportHeight() - menu_height - admin_menu_height;
        var viewport_bottom_pos = scrolled_from_top + viewportHeight();

        var viewport_width = viewportWidth();
        var wrapper_width = $(".width-wrap.landing").width();
        // var side_bar_right = ( viewport_width - wrapper_width ) / 2 - 9;
        var side_bar_right = ($(document).width() - wrapper_width) / 2;

        if (stick_back != undefined && stick_back == 1 && side_bar_height < viewport_height && (side_bar_state == "leave_middle" || side_bar_state == "stick_bottom")) {
            stick_sidebar_top();
        }

        // If smaller than viewport
        if (side_bar_height < viewport_height) {

            // Pick from the top
            if (menu_bottom_pos > top_border && side_bar_state == 'initial') {
                stick_sidebar_top();
            }

            // If larger than viewport
        } else {

            // Stick to bottom from the initial possition or from the middle
            if (side_bar_bottom_pos < viewport_bottom_pos - admin_menu_height && (side_bar_state == "initial" || side_bar_state == "leave_middle")) {
                stick_sidebar_bottom();
            }

            // Leave in middle when direction changes
            if (side_bar_state == "stick_top" && prev_scroll_pos < scrolled_from_top) {
                unstick_sidebar_middle();
            } else if (side_bar_state == "stick_bottom" && prev_scroll_pos > scrolled_from_top) {
                unstick_sidebar_middle();
            }

        }

        // Stick to top from the middle

        if (side_bar_top_pos > scrolled_from_top + menu_height - 10 && side_bar_state == "leave_middle") {
            stick_sidebar_top();
        }

        // Leave at bottom
        if (side_bar_bottom_pos > bottom_border + 18 && (side_bar_state == "stick_top" || side_bar_state == "stick_bottom")) {
            unstick_sidebar_bottom();

            // Leave at top
        } else if (menu_bottom_pos < top_border) {
            unstick_sidebar_top();

            // Pick from bottom
        } else if (side_bar_top_pos > scrolled_from_top + menu_height - 10 && side_bar_state == "leave_bottom") {
            stick_sidebar_top();
        }

        function stick_sidebar_top() {
            side_bar_state = "stick_top";

            side_bar.css('position', 'fixed');
            side_bar.css('right', side_bar_right + 'px');
            side_bar.css('top', menu_height - 10 + 'px');
            side_bar.css('bottom', 'auto');
        }

        function unstick_sidebar_top() {
            side_bar_state = "initial";

            side_bar.css('position', 'absolute');
            side_bar.css('top', '25px');
            side_bar.css('right', '25px');
            side_bar.css('bottom', 'auto');
        }

        function stick_sidebar_bottom() {
            side_bar_state = "stick_bottom";

            side_bar.css('position', 'fixed');
            side_bar.css('right', side_bar_right + 'px');
            side_bar.css('bottom', '0');
            side_bar.css('top', 'auto');
        }

        function unstick_sidebar_bottom() {
            side_bar_state = "leave_bottom";

            side_bar.css('position', 'absolute');
            side_bar.css('right', '25px');
            side_bar.css('top', 'auto');
            side_bar.css('bottom', '0px');
        }

        function unstick_sidebar_middle() {
            side_bar_state = "leave_middle";

            var top = side_bar_top_pos - top_border;
            side_bar.css('position', 'absolute');
            side_bar.css('right', '25px');
            side_bar.css('top', top + 32 + 'px');
            side_bar.css('bottom', 'auto');
        }

        prev_scroll_pos = scrolled_from_top;

    }

    $('.topics').on('click', '.remove-topic', function() {
        var topic = $(this).parent().attr('topic');
        $('label:contains(' + topic + ')').parent().removeClass('selected');
        $(this).parent().remove();
    });


    $("#test-upload").click(function() {

        var fr = new FileReader();
        var file = $('.admin-file-input')[0].files[0];
        fr.onload = function(e) {
            splitAndSendFile(new Uint8Array(e.target.result), file);
        };

        fr.readAsArrayBuffer(file);
    });

    function splitAndSendFile(dataArray, file) {
        // console.log('start');
        var i = 0,
            formData, blob;
        var chunk_size = 2 * 1024 * 1024; // 2mb
        var parts = dataArray.length / chunk_size;
        var file_size = file.size;
        // console.log("size:" + chunk_size);
        // console.log('parts ' + parts);
        formData = new FormData();

        for (i = 0; i < dataArray.length; i += chunk_size) {
            blob = new Blob([dataArray.subarray(i, i + chunk_size)]);
            formData = new FormData();
            formData.append("fileUpload", blob, file.name + ".part" + (i / chunk_size));
            formData.append("file_name", file.name);
            formData.append('action', 'ajax_test_chunk_upload');
            formData.append('parts', parts);
            formData.append('part', i / chunk_size);
            formData.append('file_size', file_size);
            formData.append('chunk_size', chunk_size);

            $.ajax({
                url: ajax_object.ajaxurl,
                type: 'post',
                data: formData,
                processData: false,
                contentType: false,
                async: false,
                success: function(msg) {
                    // console.log("Win: " + msg);
                },
                error: function(bla, msg) {
                    // console.log("Fail: " + msg);
                }
            });
        }
    }


    // ADA compliance
    // ========================================================================================
    // ========================================================================================

    // Trigger click event on button enter press
    $('.button').keypress(function(e) {
        trigger_click(e, $(this));
    });

    // Trigger click event on checkbox label enter press
    $(".checkbox-label").keypress(function(e) {
        trigger_click(e, $(this));
    });

    $(".plus-icon").keypress(function(e) {
        trigger_click(e, $(this));
    });

    $(".tab-button").keypress(function(e) {
        trigger_click(e, $(this));
    });

    $(".dropdown").keypress(function(e) {
        trigger_click(e, $(this));
    });


    $(".mobile-menu .profile-item").keypress(function(e) {
        trigger_click(e, $(this));
        $('.large-menu-holder[data-menu="profile-menu"]').focus();
    });

    $(".mobile-menu .databases-item").keypress(function(e) {
        trigger_click(e, $(this));
        $('.large-menu-holder[data-menu="large-menu"]').focus();
    });

    $(".mobile-menu .more-item").keypress(function(e) {
        trigger_click(e, $(this));
        $('.small-menu-holder[data-menu="small-menu"]').focus();
    });

    // ready made forms focus on sumoselect
    $("#selected-one-search").keypress(function(e) {
        $(".search-txt").focus();
    });

    $("#selected-benchmarks").keypress(function(e) {
        $(".search-txt").focus();
    });


    var keyboard_nav = false;
    $("html").keydown(function(e) {
        var key = e.which;
        if (key == 9 && !keyboard_nav) {
            $("head").append('<style type="text/css" >*:focus{ outline: #49a9ee solid 1px;} a:focus{ outline: #49a9ee solid 1px !important; }</style>');
        }
    });

    // universal trigger
    function trigger_click(e, element) {
        var key = e.which;
        if (key == 13) {
            element.click();
            return false;
        }
    }

    // nace sic forms
    // info icon
    // ready-made form


    // keyboard menu navigation desktop
    $(".small-menu a").focus(function() {
        var window_width = viewportWidth();

        if (window_width > 1185) {
            $(this).parents(".menu-item-has-children").find(".sub-menu").addClass("visible-sub-menu");
            $(this).parents(".menu-item-has-children").find(".sub-menu .sub-menu").remove();
        }
    });

    $(".small-menu a").focusout(function() {
        var window_width = viewportWidth();

        // if  ( window_width > 1185){
        $(this).parents(".menu-item-has-children").find(".sub-menu").removeClass("visible-sub-menu");
        // }
    });

    $(".large-menu a").focus(function() {
        var window_width = viewportWidth();

        if (window_width > 1185) {
            $(this).parents(".menu-item-has-children").find(".sub-menu").addClass("visible-sub-menu");
        }
    });

    $(".large-menu a").focusout(function() {
        var window_width = viewportWidth();

        if (window_width > 1185) {
            $(this).parents(".menu-item-has-children").find(".sub-menu").removeClass("visible-sub-menu");
        }
    });


    $('.large-menu-holder[data-menu="profile-menu"] .mobile-logout').blur(function() {
        $(".mobile-menu .databases-item").focus();
        $('.large-menu-holder[data-menu="profile-menu"]').removeClass("show");
    });

    $('.large-menu-holder[data-menu="large-menu"] .next-menu').blur(function() {
        $(".mobile-menu .more-item").focus();
        $('.large-menu-holder[data-menu="large-menu"]').removeClass("show");
    });

    $('.small-menu-holder[data-menu="small-menu"] .leave-mobile-menu').blur(function() {
        $('.small-menu-holder[data-menu="small-menu"]').removeClass("show");
    });




    // ACCESSIBILITY FORM SUBMIT
    $(".contact-us-form #submit-accessibility-form").click(function() { //contact-form-submitted
        if ($('.allow-send').val()) { //if spam input is filled then terminate
            return;
        }

        var error = false;
        var message = '';

        $('.form-message-container').css('display', 'none');
        $('.form-message-container p').text('');
        $('.contact-us-form input').removeClass('error');

        $('.contact-us-form .required').each(function(index) {
            if (!$(this).val()) {
                $(this).addClass('error');
                error = true;
                message = "You must fill all required fields.";
            }
        });

        if (error) {
            $('.form-message-bad').text(message);
            $('.form-message-container').css('display', 'block');
            return
        }

        var user_email = sanitize($('.contact-us-form input[name="user_email"]').val());
        var user_name = sanitize($('.contact-us-form input[name="user_name"]').val());
        var user_message = sanitize($('.contact-us-form textarea[name="user_message"]').val());

        if (full_name_check(user_name) == false) {
            $('.contact-us-form input[name="user_name"]').addClass('error');

            $('.form-message-container').append('<p class="form-message-bad">Please enter your full name.</p>');
            $('.form-message-container').css('display', 'block');
            return;
        }

        if (!isValidEmailAddress(user_email)) {
            $('.contact-us-form input[name="user_email"]').addClass('error');
            error = true;
            message = "The email you have entered is invalid. Pleach check again.";
        }

        if (error) {
            $('.form-message-bad').text(message);
            $('.form-message-container').css('display', 'block');
            return
        }

        // Hide button and show loader
        $(this).css('display', 'none');
        $('.loader-container').css('display', 'block');

        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            data: {
                action: "ajax_accessibility_mail",
                user_email: user_email,
                user_name: user_name,
                user_message: user_message
            },
            success: function(result) {
                $('.contact-us-form #submit-contact-form').css('display', 'block');
                $('.contact-us-form .loader-container').css('display', 'none');

                $('.contact-us-form input').val('');
                $('.contact-us-form textarea').val('');

                $('.form-message-good').text('Your message has been sent successfully!');
                $('.form-message-container').css('display', 'block');
            },
            error: function(result) {
                $('.contact-us-form #submit-contact-form').css('display', 'block');
                $('.contact-us-form .loader-container').css('display', 'none');

                $('.form-message-good').text('We are sorry, but an error occured while sending your message, please try again later.');
                $('.form-message-container').css('display', 'block');
            }
        });

    })


    function full_name_check(user_name) {
        if (user_name == undefined) {
            return true;
        }
        var name_arr = user_name.split(" ");
        var length = name_arr.length;
        if (length < 2) {
            return false;
        }

        return true;
    }


    var active_slide = 0;
    // Home page menu functions
    $(document).ready(function() {
        // if home - active first menu item
        var window_width = viewportWidth();

        // if not mobile
        if (window_width >= 1185) {

            // select_default_active_large_menu_element();

            function select_default_active_large_menu_element() {
                $('.large-menu li').removeClass('active');

                if ($("#menu-item-4306").hasClass('current_page_parent')) {
                    $("#menu-item-4306").addClass('active')
                } else if ($("#menu-item-4305").hasClass('current_page_parent')) {
                    $("#menu-item-4305").addClass('active')
                } else if ($("#menu-item-2871").hasClass('current_page_parent')) {
                    $("#menu-item-2871").addClass('active')
                } else if ($("#menu-item-2902").hasClass('current_page_parent')) {
                    $("#menu-item-2902").addClass('active');
                } else if ($("#menu-item-4431").hasClass('current_page_parent')) {
                    $("#menu-item-4431").addClass('active');
                } else if ($("#menu-item-4432").hasClass('current_page_parent')) {
                    $("#menu-item-4432").addClass('active');
                } else if ($("#menu-item-3113").hasClass('current_page_parent')) { // local
                    $("#menu-item-3113").addClass('active')
                } else if ($("#menu-item-3111").hasClass('current_page_parent')) { // local
                    $("#menu-item-3111").addClass('active');
                } else if ($("#menu-item-2886").hasClass('current_page_parent')) { // local
                    $("#menu-item-2886").addClass('active');
                } else if ($("#menu-item-3114").hasClass('current_page_parent')) { // local
                    $("#menu-item-3114").addClass('active');
                } else if ($("#menu-item-2869").hasClass('current-menu-item')) { // local
                    $("#menu-item-2869").removeClass('active');
                    $("#menu-item-2869").removeClass('current-menu-item');
                } else {

                    // $('.large-menu li:first-of-type').addClass('active');
                }
            }

            if ($("#menu-item-4306").hasClass('current-menu-item')) { // local
                $("#menu-item-4306").removeClass('active');
                $("#menu-item-4306").removeClass('current-menu-item');
                $("#menu-item-4306").removeClass('current_page_item');
            }


            if ($("#menu-item-2869").hasClass('current-menu-item')) { // local
                $("#menu-item-2869").removeClass('active');
                $("#menu-item-2869").removeClass('current-menu-item');
                $("#menu-item-2869").removeClass('current_page_item');
            }


            if ($("#header").hasClass('front-page')) {
                $('.large-menu li a').mouseenter(function() {
                    // set_header_slide($(this));
                });
            } else {
                $(".large-menu li").each(function() {

                    if ($(this).hasClass('current-menu-ancestor')) {
                        // console.log($(this));
                        $(this).addClass('active');
                    }
                });
                // $('.large-menu li a').mouseenter(function() {

                //     if ($(this).parent('li').hasClass('menu-item-1208')) {

                //         // } else if ($(this).parent('li').hasClass('menu-item-4305')) {

                //         // } else if ($(this).parent('li').hasClass('menu-item-4306')) {

                //     } else {
                //         // console.log('in2');
                //         // remove active classes only if first level item
                //         // window.setTimeout(function() {
                //         $('.large-menu li').removeClass('active');
                //         $(this).parent('li').addClass('active');
                //         // console.log('in3');
                //         // }, 1000);

                //         //
                //         if ($(this).parents('li').hasClass('current_page_parent')) {
                //             $(this).parents('li.current_page_parent').addClass('active');
                //         }

                //     }


                // });

                $('.large-menu').mouseleave(function() {
                    // select_default_active_large_menu_element();
                });

            }

            function set_header_slide(element) {
                if (element.parents('.sub-menu').length) {
                    return;
                }

                var from_top = $(window).scrollTop();

                var slide_index = element.parents('.large-menu li').index();
                if (slide_index < 3) {
                    $('.large-menu li').removeClass('active');
                    if (from_top <= 44) {
                        element.parents('.large-menu li').addClass('active');
                    }

                    active_slide = slide_index
                        // $('.front-page-slider').slick('slickGoTo', active_slide);
                }
            }

            // $('.front-page-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
            //
            //     setTimeout(function(){
            //         if (active_slide !== currentSlide){
            //             $('.front-page-slider').slick('slickGoTo', active_slide);
            //         }
            //     }, 100);
            //
            // });
            //
            // if ( $('.front-page-slider').length >= 1 ){
            //     $('.front-page-slider').slick({
            //              dots: false,
            //              infinite: false,
            //              speed: 600,
            //              slidesToShow: 1,
            //              slidesToScroll: 1,
            //              autoplay: false,
            //              draggable: false,
            //              arrows: false,
            //        });
            // }
        }

    });

    $(".key-features ul.features .heading").click(function() {
        // $(this).parent().
        if ($(this).parent().hasClass('active')) {
            $(this).parent().removeClass('active')
        } else {
            // $(".key-features ul.features .heading").parent().removeClass('active');
            $(this).parent().addClass('active')
        }
    });

        // initialize sliders
        $(document).ready(function() {

            if ($('.clients-slider').length >= 1) {
                $('.clients-slider').slick({
                    dots: true,
                    infinite: false,
                    speed: 600,
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    autoplay: true,
                    autoplaySpeed: 14000,
                    infinite: true,
                    nextArrow: '<a tabindex="0" class="slick-next"></a>',
                    prevArrow: '<a tabindex="0" class="slick-prev"></a>',
                    responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 4,
                                infinite: true,
                                dots: true
                            }
                        },
                        {
                            breakpoint: 800,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        }
                    ]
                });
                $('.clients-slider').css('opacity', '1');
                $('.clients-headding').css('opacity', '1');
            }
    
            if ($('.clients-slider-2').length >= 1) {
    
                $('.clients-slider-2').slick({
                    dots: true,
                    infinite: false,
                    speed: 600,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    autoplay: true,
                    autoplaySpeed: 12000,
                    infinite: true,
                    lazyLoad: 'ondemand',
                    nextArrow: '<a tabindex="0" class="slick-next"></a>',
                    prevArrow: '<a tabindex="0" class="slick-prev"></a>',
                    responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                                infinite: true,
                                dots: true
                            }
                        },
                        {
                            breakpoint: 800,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
    
                $('.clients-slider-2').css('opacity', '1');
            }
    
            // PEOPLE SLIDER
            if ($('.people-slider').length >= 1) {
    
                $('.people-slider').slick({
                    dots: true,
                    infinite: false,
                    speed: 600,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 10000,
                    infinite: true,
                    arrows: false,
                    lazyLoad: 'ondemand',
                });
    
                $('.people-slider').css('opacity', '1');
            }
    
    
            // TESTIMONIALS SLIDER
            if ($('.testimonials-slider').length >= 1) {
    
                $('.testimonials-slider').slick({
                    dots: true,
                    infinite: false,
                    speed: 600,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 6000,
                    infinite: true,
                    nextArrow: '<a class="slick-next"></a>',
                    prevArrow: '<a class="slick-prev"></a>',
                });
    
                $('.testimonials-slider').css('opacity', '1');
                $('.testimonials-slider-holder h3').css('opacity', '1');
    
            }
    
    
        });

    // $("#profitlevel-form ul.options>li.group:nth-of-type(1)").click(function() {
    //     console.log('testas');
    // });


    // $('.plus-icon').on('click', function($) {

    // });

})(jQuery);

jQuery(document).ready(function() {
    if (jQuery('.owl-carousel').length) {
        var viewedSlider = jQuery('.owl-carousel');

        viewedSlider.owlCarousel({
            loop: true,
            margin: 42,
            autoplay: false,
            autoplayTimeout: 5000,
            nav: true,
            dots: false,
            mouseDrag: true,
            smartSpeed: 500,
            navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
            responsive: {
                0: {
                    items: 1,
                    margin: 40
                },
                575: {
                    items: 1,
                    margin: 40
                },
                767: {
                    items: 1,
                    margin: 40
                },
                992: {
                    items: 2,
                    margin: 40
                },
                1200: {
                    items: 3,
                    margin: 40
                },
            }
        });
    }
});